import {
    Component,
    OnChanges,
    Input,
    LOCALE_ID,
    Inject,
    Output,
    EventEmitter,
    SimpleChanges,
    OnDestroy,
} from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { EnrollPatientDeviceDataService } from '../../../services/enroll-patient-device-data.service';
import {
    PatientDeviceDataModel,
    UpdatePatientDeviceDataModel,
    ClinicDetailsModel,
    DropDownModel,
    MessagingModel,
    PatientDeviceModel,
    PatientDetailsModel,
} from '../../../models/enroll-patient-device-data.model';
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import {
    CountryCdEnum,
    SpinnerService,
} from 'merlin-library';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { HelperService, ToasterClass } from 'merlin-core';
import { AbstractControl } from '@angular/forms';
import { FrontEndErrMsgs } from '../../../enums/patient-device-data.enum';

import { DatePipe } from '@angular/common';
import { DateTimeService } from '../../followup-schedule/date-time.service';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from '../../followup-schedule/customDateAdapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { UserProfileObject } from 'merlin-library';
import { ViewEncapsulation } from '@angular/core';
import {
    LocalizationService,
    ReturnType,
} from 'src/core/utilitites/localization.service';
import { ErrorCodes } from '../../../enums/error-codes.enum';
import { ToastrService } from 'ngx-toastr';
import { FunctionMode } from '../../enums/enroll-patient.enum';
import { PatientTransferRequestClinicService } from '../../../services/patient-transfer-request-clinic.service';
import { ActionError } from '../../../../my-account/services/my-account.model';
import { catchError, map, takeUntil } from 'rxjs/operators';
import dayjs from 'dayjs';
import { FRANCE_COUNTRY_CODE } from '../../../../constants/france.constants';
import { TransmissionDetailService } from '../../../services/transmission-detail.service';
import { CommonService } from '../../../../shared/service/common.service';
import { InsInformationDialogComponent } from '../ins-information-dialog/ins-information-dialog.component';
import { Subject, Subscription, of } from 'rxjs';
import { DVCCALRT, DVCDCALRT, PROG_STATE_FAIL_CD } from '../../../../constants/Programming_Failure_Reason_Cd.constants';
import { AVEIR_ALL_CODES } from '../device-transmit-information/device-codes.constants';
export const isControlRequired = (control: AbstractControl): boolean => {
    if (!control) {
        return false;
    }

    if (control.validator) {
        const validator = control.validator({} as AbstractControl);
        if (validator && validator.required) {
            if (!control.value || control.value === '') {
                return true;
            } else {
                return false;
            }
        }
    }
    if (control?.errors?.required) {
        return true;
    }

    return false;
};

export const PICK_FORMATS = {
    parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'short' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' },
    },
};

@Component({
    selector: 'edit-manual-patient-device-data',
    templateUrl: './edit-patient-device-data.component.html',
    styleUrls: ['./edit-patient-device-data.component.scss'],
    providers: [
        DatePipe,
        DateTimeService,
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [DateTimeService],
        },
        { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditPatientDeviceDataComponent implements OnChanges, OnDestroy {
    public isAPIError: boolean = false;
    public patientDeviceForm: FormGroup;
    public deviceForm: FormGroup;
    public patientDetailsForm: FormGroup;
    public addressDetails: FormGroup;
    public messageForm: FormGroup;
    public phoneForm: FormGroup;
    public patientDeviceData: PatientDeviceDataModel;
    public existingData;
    public clinicDetailsInfo: ClinicDetailsModel;
    public dropDownInfo: DropDownModel = new DropDownModel();
    public messagingInfo: MessagingModel;
    public PatientInfo: PatientDetailsModel;
    public patientDeviceInfo: PatientDeviceModel;
    public implantPhyId = null;
    public showPhysicianOpt: boolean = false;
    public showMarkImplantingButton = false;
    public isNGQCategory = false;
    public isICMCategory = false;
    public isLPCategory:boolean = false;
    public isUnityCategory: boolean = false;
    public isAVRCategory = false;
    public emailValidations = false;
    public dataMiningFlg: boolean = false;
    public avaliableIds = [];
    public assignedIds = [];
    public selectedAssignedIds = [];
    public remainAvaliableIds = [];
    public toggleEmergencyCont = false;
    public callingEmergencyCont = false;
    public dateLabel: string;
    public implantIds = [];
    public dataMsgs = [];
    public updateDevideInfo: UpdatePatientDeviceDataModel = new UpdatePatientDeviceDataModel();
    public togglePatientValidation: boolean = true;
    public togglePatientIdValidation: boolean = true;
    public showAddrValidations: boolean = false;
    public phoneValidations: boolean = false;
    public medicalOnCallSel: boolean = false;
    public isError = false;
    public errorHeading;
    public countryCd;
    public emptyErrors = [];
    public errorMsgs = [];
    public patternError = [];
    public userInfo: UserProfileObject;
    public isUpdate = false;
    public transmitterOrderFlg: boolean = false;
    public isConfirmClick: boolean = false;
    public prevInsNumber = '';
    private destroy$ = new Subject<void>();
    private profileSubscription: Subscription;

    ddMMDateRegex = /^(0?[1-9]|[12][0-9]|3[01])([-/.])(0?[1-9]|1[012])\2((?!0000)\d{4})$/;
    yyMMddRegex = /^((?!0000)\d{4})([-/.])(0?[1-9]|1[012])\2(0?[1-9]|[12][0-9]|3[01])$/;
    dateRegex = /^(0?[1-9]|1[012])([-/.])(0?[1-9]|[12][0-9]|3[01])\2((?!0000)\d{4})$/;
    patientInfo: any;
    displayMode: string = FunctionMode.EDIT;
    patRes: any = {};
    patResSet = false;
    orderTransmitter: boolean;
    orderTransmitterMsg: string = '';
    msg1: string = '';
    msg2: string = '';
    msg3: string = '';
    hasPatientDataEntryAccess: boolean;
    isPatientRelease: boolean = false;
    isSP2CanEnroll: boolean;
    isCountryFrance: boolean;
    tempValSerial: any;
    drtempValSerial: any;
    tempValModel: any;
    drtempValModel: any;
    patientData: any;
    isSaveClick: boolean;
    isSavebtnClick: boolean;
    isContinueClick: boolean;
    cancelledCM819: boolean;
    productName: boolean = false;
    isEnrollByIns: any = false;
    noEdit: boolean;
    cliniciansList: any;
    activatorClinicFlg: boolean = false;
    userProfile: UserProfileObject;
    releasePatientMsg: string;
    updatedDevice: boolean = false;
    editReason: string = "CorrectDevice";
    testValue = "its working";
    transmissionCount =0;
    isAveirDevice: boolean = false;
    private readonly aveirAllCodes = new Set(AVEIR_ALL_CODES);
    private initialMsgOverdueFlg: boolean | null = null;
    private initialMsgReminderFlg: boolean | null = null;
    private msgFlagsInitialized: boolean = false;
    msgReminderFlgValue: any = null;
    msgOverdueFlgValue: any = null;

    @Input('functionMode') functionMode: string;
    @Input() patientid;
    @Input() rpCapableFlg;
    @Input() isBack;
    @Input() defaultPatientDetails: PatientDetailsModel;
    @Input() getUserObsFunc;
    @Input() getUserProfFunc;
    @Input() getDeviceDataFunc;
    @Input() getExistingPatientFunc;
    @Input() getEnrollPatientsFunc;
    @Input() getEnrollPatientByInsFunc;
    @Input() getUpdateDeviceDataFunc;
    @Input() setParentPatientid;
    @Input() setParentDisplayMode;
    @Input() isActiveStep: boolean = true;

    @Output() navigateToTrans = new EventEmitter();
    @Output() getPatientId = new EventEmitter();
    @Output() setPatientHeader = new EventEmitter();
    @Output() setSubMenu = new EventEmitter();
    @Output() setDeviceData = new EventEmitter();
    constructor(
        private fb: FormBuilder,
        private helperService: HelperService,
        private spinnerSer: SpinnerService,
        private router: Router,
        @Inject(LOCALE_ID) public locale: string,
        private enrollService: EnrollPatientDeviceDataService,
        private dateFormatService: DateTimeService,
        private dialog: MatDialog,
        private localizationService: LocalizationService,
        private toasterService: ToastrService,
        private route: ActivatedRoute,
        private requestService: PatientTransferRequestClinicService,
        private transmissionDetailService: TransmissionDetailService,
        private commonService: CommonService,
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.isBack != undefined) {
            if (changes.isBack.currentValue) {
                this.setDisplayMode(FunctionMode.ENROLL);
                this.functionMode = FunctionMode.ENROLL;
                this.getExistingDeviceData();
            }
        }
        if (changes?.functionMode?.currentValue === FunctionMode.ENROLL) {
            this.setDisplayMode(FunctionMode.ENROLL);
        }
    }

    ngOnInit() {
        this.setUpComponent();
        this.enrollService.isICMDevice = false;
        this.toggleEmergencyCont = false;
        this.getUserObsFunc((existingUser: UserProfileObject) => {
                if (!existingUser) {
                    this.getUserProfFunc((userProfile: UserProfileObject) => {
                            this.userProfile = userProfile;
                            this.activatorClinicFlg =
                                userProfile.activatorClinicFlg;
                            this.isSP2CanEnroll =
                                userProfile.customerType === 'CL'
                                    ? true
                                    : userProfile?.customerType === 'SP2' &&
                                    userProfile?.canEnroll;
                            this.dateLabel = userProfile?.dateFormat?.toUpperCase();
                            this.setValidatorForDOB(userProfile);
                            this.setValidatorForImplantDate();
                        });
                } else {
                    this.userProfile = existingUser;
                    this.isSP2CanEnroll =
                        existingUser.customerType === 'CL'
                            ? true
                            : existingUser?.customerType === 'SP2' &&
                            existingUser?.canEnroll;
                    this.activatorClinicFlg = existingUser.activatorClinicFlg;
                    this.dateLabel = existingUser?.dateFormat?.toUpperCase();
                    this.setValidatorForDOB(existingUser);
                    this.setValidatorForImplantDate();
                }
            });
        this.enrollService.showEmergencyContactPopup.next(false);
        this.route.params.subscribe((res) => {
            if (res?.id) {
                this.patientid = res.id;
                this.setParentPatientid(res.id);
                this.enrollService.patientId.next(res.id);
            }
        });

        this.enrollService.updateDeviceFormDirty(false);
        this.patientDeviceForm.valueChanges.subscribe(() => {
            if (!this.isActiveStep) {
                return;
            }
            this.enrollService.updateDeviceFormDirty(
                this.patientDeviceForm.dirty
            );

            if (this.functionMode == 'enroll' || this.displayMode == 'enroll') {
                // Removed toasterService.clear() - it was clearing validation toasts from other components (PA857b)
                // if (this.patientDeviceForm.valid && !this.isAPIError && this.dialog.openDialogs.length === 0) {
                //     this.toasterService.clear();
                // }
            }
        });
        if (this.defaultPatientDetails !== undefined) {
            if (this.defaultPatientDetails?.insNumber != '' && this.defaultPatientDetails?.oidNumber != '')
                this.isEnrollByIns = true;
            this.togglePatientIdValidation = false;
            this.patientDeviceForm
                .get('patientDetails')
                .get('patientNum')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('patientNum')
                .setErrors(null);
        }
        this.onDateRangeChange();
    }

    ngOnDestroy(): void {
        if(this.profileSubscription){
            this.profileSubscription.unsubscribe();
        }
        this.enrollService.showEmergencyContactPopup.next(false);
        this.toggleEmergencyCont = false;
        this.callingEmergencyCont = false;
        let st = [this.patientDeviceForm.dirty,
        this.deviceForm.dirty,
        this.addressDetails.dirty,
        this.messageForm.dirty,
        this.phoneForm.dirty].some(fdty => fdty === true);
        this.enrollService.updateDeviceFormDirty(st);
        this.destroy$.next();
        this.destroy$.complete();
    }

    getPatientProfile(res) {
        const patientDevice = this.enrollService.getPrimaryPatientDevice(res);
        if (res && this.activatorClinicFlg && patientDevice) {
            let banner = {
                deviceFullDescription: patientDevice?.deviceFullDescription,
                firstName: res?.patient?.firstName,
                lastName: res?.patient?.lastName,
                patientNum: res?.patient?.patientNum
            }
            this.transmissionDetailService.setBanner(banner);
        }
        this.enrollService.setAssociatedClinicFlag(res.clinicDetails.associatedClinicFlg);
        this.enrollService.setPatientRpCapableFlg(patientDevice?.patientRpCapableFlg);
        this.isPatientRelease = res?.patient?.patientStatusCd === 48 && res?.actionMsg !== null;
        this.releasePatientMsg = this.localizationService.generateLocalizedStr(
            'msg.pa834a.text',
            null,
            'html'
        );
        if (
            res.actionMsg?.msg &&
            (res.actionMsg?.msg === 'msg.pa892.text' ||
                res.actionMsg?.msg === 'msg.patrel_regclinic.text' ||
                res.actionMsg?.msg === 'msg.patrel_actclinic.text')
        ) {
            let message = this.translate(
                res.actionMsg?.msg,
                { 0: res.actionMsg.data[0], 1: res.actionMsg.data[1] },
                ReturnType.HTML
            );
            this.isPatientRelease = true;
            this.releasePatientMsg = message;
        }

        this.patientInfo = res;
        if (
            this.patientInfo.showDeviceAtEos != null &&
            this.patientInfo.showDeviceAtEos != false
        ) {
            this.msg1 = this.translate('msg.pa900.text', null, ReturnType.Text);
        } else {
            this.msg1 = "";
        }
        if (
            this.patientInfo.correctAbbrDevModelDesc != null &&
            this.patientInfo.correctAbbrDevModelDesc != ''
        ) {
            this.msg2 = this.translate(
                'msg.pa899.text',
                { '0': this.patientInfo.correctAbbrDevModelDesc },
                ReturnType.Text
            );
        } else {
            this.msg2 = "";
        }

        if (
            this.patientInfo.showYellowBannerForApp != null &&
            this.patientInfo.showYellowBannerForApp != false
        ) {
            this.msg3 = this.translate('msg.pa890.text', null, ReturnType.Text);
        } else {
            this.msg3 = "";
        }
    }

    setUpComponent() {
        this.generateReactiveForm();
        if (this.isBack) {
            this.getExistingDeviceData();
        } else {
            this.getDeviceData();
        }
        this.getUserProfFunc((res: UserProfileObject) => {
                if (res) {
                    this.userInfo = res;
                    this.dateLabel = res?.dateFormat?.toUpperCase();
                    this.isCountryFrance =
                        res.clinicCountryCd === FRANCE_COUNTRY_CODE;
                    if (this.isCountryFrance) {
                        this.patientDetailsForm
                            .get('genderCd')
                            .setValidators(Validators.required);
                    }
                    this.activatorClinicFlg = res.activatorClinicFlg;
                    this.hasPatientDataEntryAccess = this.userInfo?.canEnroll;
                    this.countryCd = res.clinicCountryCd;
                    this.isSP2CanEnroll =
                        this.userInfo.customerType === 'CL'
                            ? true
                            : this.userInfo?.customerType === 'SP2' &&
                            this.userInfo?.canEnroll;
                    this.setValidatorForImplantDate();
                }
            });
    }

    public getExistingDeviceData() {
        let patientID;
        this.spinnerSer.visibility = true;
        this.enrollService.patientId.subscribe(
            (data) => {
                patientID = data;
                if (patientID) {
                    this.getExistingPatientFunc(
                        patientID,
                        (res) => {
                            const patientDevice = this.enrollService.getPrimaryPatientDevice(res);
                            if (res?.messaging?.callContactTypeCd == 995) {
                                this.messageForm.addControl(
                                    'patientCallSMS',
                                    this.fb.control('', Validators.required)
                                );
                            }
                            this.enrollService.isICMDevice =
                                patientDevice?.isICMDevice ?? false;
                            localStorage.setItem('rpCapableFlg', String(patientDevice?.patientRpCapableFlg ?? false));
                            this.setHeader(res);
                            this.dateFormatService.format =
                                this.userInfo?.dateFormat;
                            // this.dateLabel.next(this.userInfo?.dateFormat.toUpperCase())
                            this.dateLabel =
                                this.userInfo?.dateFormat?.toUpperCase();
                            patientDevice.transPatientImplantPhyIdData = this.enrollService.getTransferredImplantingPhys(patientDevice);
                            this.deviceForm.patchValue(
                                this.removeNulls(patientDevice)
                            );
                            if (res?.patientDevices && res?.patientDevices?.length === 2) {
                                const secondDevice = res.patientDevices[1];
                                this.deviceForm.patchValue({
                                    drDevice: true,
                                    drSerialNum: secondDevice.serialNum || '',
                                    drPrevProductId: secondDevice.prevProductId || '',
                                    drPrevSerialNum: secondDevice.prevSerialNum || '',
                                    drPatientDeviceId: secondDevice.patientDeviceId || '',
                                    drPrevPatientDeviceId: secondDevice.prevPatientDeviceId || '',
                                    drProductId: secondDevice.productId || '',
                                    drImplantDate: secondDevice.implantDate || '',
                                    drImplantPhyId: secondDevice.implantPhyId || '',
                                    drTransPatientImplantPhyIdData: this.enrollService.getTransferredImplantingPhys(secondDevice),
                                    drEditReason:secondDevice.editReason || '',
                                    drDevChanged: secondDevice.devChanged || false,
                                    isImplantPhysicianEditableDR: secondDevice.isImplantPhysicianEditable ?? true
                                });
                            }
                            this.patientDetailsForm.patchValue(
                                this.removeNulls(res.patient)
                            );
                            this.messageForm.patchValue(
                                this.removeNulls(res.messaging)
                            );
                            this.deviceForm
                                .get('transmitter')
                                .setValue(res.patient.transmitterOrderFlg);
                            this.isUpdate = true;
                            this.patientDeviceData = res;
                            this.patResSet = res.messaging != null ? true : false;
                            this.clinicDetailsInfo =
                                this.patientDeviceData.clinicDetails;
                            this.countryCd = this.userInfo.clinicCountryCd;
                            this.messagingInfo = this.patientDeviceData.messaging;
                            this.PatientInfo = this.patientDeviceData.patient;
                            this.patientDeviceInfo = patientDevice;
                            this.dataMiningFlg = this.PatientInfo.dataMiningFlg;
                            //this.setDefaultValues();
                            this.assignLists();
                            this.dropDownInfo = this.patientDeviceData.dropdowns;
                            if (patientDevice?.productId) {
                                this.togglePhysicianOpt(patientDevice.productId.toString());
                            }

                            this.spinnerSer.visibility = false;
                            this.getPatientProfile(res);
                        },
                        (err) => {
                            this.helperService.showErrorToastr(err);
                            this.spinnerSer.visibility = false;
                            // this.getPatientProfile();
                        }
                    );
                }
            },
            (err) => {
                this.helperService.showErrorToastr(err);
                this.spinnerSer.visibility = false;
                // this.getPatientProfile();
            }
        );
    }

    public getDeviceData(emergency: boolean = false) {
        this.spinnerSer.visibility = true;
        this.patResSet = false;
        let res = this.route.snapshot.params;
            if (res?.id) {
                this.patientid = res.id;
                this.setParentPatientid(res.id);
                this.enrollService.patientId.next(res.id);
            }
            if (!this.functionMode && !this.patientid) {
                this.functionMode = FunctionMode.ENROLL;
            }
                if (
                    res?.id &&
                    this.functionMode === FunctionMode.ENROLL
                ) {
                    this.enrollService.patientId.next(res.id);
                    this.getEnrollPatientsFunc(
                        res.id,
                        (res) => {
                            const patientDevice = this.enrollService.getPrimaryPatientDevice(res);
                            const prodId = patientDevice?.productId;
                            let isAddressReq = [271, 288].includes(prodId) ||
                                this.aveirAllCodes.has(String(prodId));
                            setTimeout(() => {
                                this.enrollService.addressRequired.next(
                                    isAddressReq
                                );
                            }, 1000);
                            this.bindData(emergency, res);
                            this.enrollService.isICMDevice =
                                patientDevice?.isICMDevice ?? false;
                            localStorage.setItem('rpCapableFlg', String(patientDevice?.patientRpCapableFlg ?? false));
                            this.getPatientProfile(res);
                        },
                        (err) => {
                            if (!err.actionErrors) {
                                this.helperService.showErrorToastr(err);
                            }
                            this.spinnerSer.visibility = false;
                        }
                    );
                } else {
                    this.getDeviceDataFunc(
                            this.functionMode,
                            this.patientid,
                            (res) => {
                                const patientDevice = this.enrollService.getPrimaryPatientDevice(res);
                                const prodId = patientDevice?.productId;
                                let isAddressReq = [271, 288].includes(prodId) ||
                                    this.aveirAllCodes.has(String(prodId));
                                setTimeout(() => {
                                    this.enrollService.addressRequired.next(
                                        isAddressReq
                                    );
                                }, 1000);
                                this.bindData(emergency, res);
                                this.enrollService.isICMDevice =
                                    patientDevice?.isICMDevice;
                                this.enrollService.setPatientRpCapableFlg(patientDevice?.patientRpCapableFlg ?? false);
                                localStorage.setItem('rpCapableFlg', String(patientDevice?.patientRpCapableFlg ?? false));
                                this.getPatientProfile(res);
                            },
                            (err) => {
                                this.helperService.showErrorToastr(err);
                                this.spinnerSer.visibility = false;
                            }
                        );
                }
    }
    bindData(emergency, res) {
        this.transmissionCount = res.transmissionCount ||0;
        this.isAveirDevice = res?.patientDevices?.[0]?.isAveirDevice || false;
        const patientDevice = this.enrollService.getPrimaryPatientDevice(res);
        if (res.patient?.patientId == -1 && this.patientid?.length > 0) {
            res.patient.patientId = this.patientid;
        }
        this.setHeader(res);
        const rpCapableValue = patientDevice?.patientRpCapableFlg ?? false;
        localStorage.setItem('rpCapableFlg', String(rpCapableValue));
        let capableFlg = rpCapableValue;
        //console.log(capableFlg);
        this.emitSubMenuData(patientDevice?.isICMDevice);
        this.patRes = JSON.parse(JSON.stringify(res));
        this.requestService.setPatientProfile(this.patRes);
        this.orderTransmitter = res.transmitterOrderFlg;
        this.patResSet = true;
        this.dateFormatService.format = this.userInfo?.dateFormat;
        this.dateLabel = this.userInfo?.dateFormat?.toUpperCase();
        //  this.dateLabel.next(this.userInfo?.dateFormat.toUpperCase())
        // Zip code and address validators are set by updateAddressValidations()
        // which is called from togglePhysicianOpt() later in this method.
        // This ensures validators are device-type-aware (not just country-based).
        if (res?.patient.address?.countryCd != 140) {
            this.patientDetailsForm.get('address').get('zipCode').setValidators(
                [Validators.pattern(new RegExp(/^[0-9]*$/))]
            );
            this.patientDetailsForm.get('address').get('zipCode').updateValueAndValidity();
        }
        if (!emergency) {
            this.deviceForm.patchValue(this.removeNulls(patientDevice));

            // Populate DR device fields if there's a second device (for Aveir devices)
            if (res.patientDevices && res.patientDevices.length === 2) {
                const secondDevice = res.patientDevices[1];
                this.deviceForm.patchValue({
                    drDevice: true,
                    drSerialNum: secondDevice.serialNum || '',
                    drPrevProductId: secondDevice.prevProductId || '',
                    drPrevSerialNum: secondDevice.prevSerialNum || '',
                    drPatientDeviceId: secondDevice.patientDeviceId || '',
                    drPrevPatientDeviceId: secondDevice.prevPatientDeviceId || '',
                    drProductId: secondDevice.productId || '',
                    drImplantDate: secondDevice.implantDate || '',
                    drImplantPhyId: secondDevice.implantPhyId || '',
                    drEditReason:secondDevice.editReason || '',
                    drDevChanged: secondDevice.devChanged || false,
                });
            }

            if (this.defaultPatientDetails === undefined) {
                this.patientDetailsForm.patchValue(
                    this.removeNulls(res.patient)
                );
            }
            if (res.messaging) {
                this.messageForm.patchValue(this.removeNulls(res.messaging));
            }
            this.deviceForm
                .get('transmitter')
                .setValue(res.patient.transmitterOrderFlg);
            this.patientDeviceData = res;
            this.existingData = res;
            this.clinicDetailsInfo = this.patientDeviceData.clinicDetails;
            this.countryCd = this.userInfo?.clinicCountryCd;
            this.messagingInfo = this.patientDeviceData.messaging;
            this.PatientInfo = this.patientDeviceData.patient;
            this.patientDeviceInfo = patientDevice;
            this.dataMiningFlg = this.PatientInfo.dataMiningFlg;
            if (this.functionMode == FunctionMode.ENROLL) {
                this.setDefaultValues();
                this.initializeMsgFlagTracking();
            }
            this.assignLists();
            this.dropDownInfo = this.patientDeviceData.dropdowns;
            this.cliniciansList = res.dropdowns.clinicians;
            if (patientDevice?.productId) {
                this.togglePhysicianOpt(patientDevice.productId.toString());
            }

            this.spinnerSer.visibility = false;
            this.getPatientProfile(res);
        }
    }

    public patientNumberChange(change) {
        if (change) {
            this.togglePatientValidation = false;
            this.patientDeviceForm
                .get('patientDetails')
                .get('firstName')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('lastName')
                .clearValidators();
        } else {
            this.togglePatientValidation = true;
            this.patientDeviceForm
                .get('patientDetails')
                .get('firstName')
                .setValidators(Validators.required);
            this.patientDeviceForm
                .get('patientDetails')
                .get('lastName')
                .setValidators(Validators.required);
        }
    }

    public nameValueChange(change) {
        if (change) {
            this.togglePatientIdValidation = false;
            this.patientDeviceForm
                .get('patientDetails')
                .get('patientNum')
                .clearValidators();
        } else {
            if (
                this.patientDeviceForm.get('patientDetails').get('firstName')
                    .value ||
                this.patientDeviceForm.get('patientDetails').get('lastName')
                    .value
            ) {
                this.togglePatientIdValidation = false;
                this.patientDeviceForm
                    .get('patientDetails')
                    .get('patientNum')
                    .clearValidators();
            } else {
                this.togglePatientIdValidation = true;
                this.patientDeviceForm
                    .get('patientDetails')
                    .get('patientNum')
                    .setValidators(Validators.required);
            }
        }
    }

    public setDefaultValues() {
        let patientCountryCd = this.patientDetailsForm?.get('address')?.get('countryCd')?.value;
        let userCountryCd = this.userInfo?.clinicCountryCd; 
        if(patientCountryCd == null || patientCountryCd == '') {
            this.patientDetailsForm
                ?.get('address')
                ?.get('countryCd')
                ?.setValue(this.removeNulls(this.userInfo?.clinicCountryCd));
            this.addressDetails
                ?.get('countryCd')
                ?.setValue(this.removeNulls(this.userInfo?.clinicCountryCd));
        }
        
        this.messageForm
            .get('msgReminderFlg')
            .setValue(this.removeNulls(this.messagingInfo?.msgReminderFlg));
        this.messageForm
            .get('msgOverdueFlg')
            .setValue(this.messagingInfo?.msgOverdueFlg);
        if (this.functionMode == FunctionMode.ENROLL) {
            this.route.params.subscribe((res) => {
                if (!res?.id) {
                    const mode =
                        this.userProfile?.dateFormat != null
                            ? this.userProfile?.dateFormat?.toUpperCase()
                            : 'MM-DD-YYYY';
                    let todayDate = dayjs().format(mode);
                    // (this.patientDeviceForm.get('deviceData') as FormGroup).get('implantDate').setValue(todayDate);
                }
            });
        }
    }

    private initializeMsgFlagTracking() {
        // Capture initial values after form is populated for enrollment
        // These will be compared at save time to determine if user made changes
        if (!this.msgFlagsInitialized) {
            this.initialMsgOverdueFlg = this.messageForm.get('msgOverdueFlg')?.value ?? null;
            this.initialMsgReminderFlg = this.messageForm.get('msgReminderFlg')?.value ?? null;
            this.msgFlagsInitialized = true;
        }
    }

    setValidatorForDOB(userProfile: any) {
        let dRegex =
            userProfile.dateFormat == 'dd-MM-yyyy'
                ? this.ddMMDateRegex
                : userProfile.dateFormat == 'yyyy-MM-dd'
                    ? this.yyMMddRegex
                    : this.dateRegex;
        (this.patientDeviceForm?.get('patientDetails') as FormGroup).controls[
            'dateOfBirthStr'
        ].clearValidators();
        (this.patientDeviceForm?.get('patientDetails') as FormGroup).controls[
            'dateOfBirthStr'
        ].setValidators([Validators.required, Validators.pattern(dRegex),
            (control) => {
                if (!control.value) {
                    return null;
                }
                const isValid = this.helperService.dateValidator(control.value, userProfile.dateFormat);
                return isValid ? null : { incorrect: true };
            }
        ]);
    }

    setValidatorForImplantDate() {
        (this.patientDeviceForm?.get('deviceData') as FormGroup)?.controls[
            'implantDate'
        ].clearValidators();
        if (this.isICMCategory) {
            (this.patientDeviceForm?.get('deviceData') as FormGroup)?.controls[
                'implantDate'
            ].setValidators(this.addValidatorsToImplantDate());
        }
    }

    public generateReactiveForm() {
        this.patientDeviceForm = this.fb.group({
            deviceData: this.buildDeviceData(),
            patientDetails: this.buildPatientDetails(),
            directCallMsg: this.buildDirectCallMsg(),
        });
    }

    public addValidatorsToImplantDate() {
        let dRegex =
            this.userProfile?.dateFormat == 'dd-MM-yyyy'
                ? this.ddMMDateRegex
                : this.userProfile?.dateFormat == 'yyyy-MM-dd'
                    ? this.yyMMddRegex
                    : this.dateRegex;
        let validators = [Validators.pattern(dRegex)];
        if (this.countryCd == '140') validators.push(Validators.required);
        return validators;
    }
    public buildDeviceData() {
        return (this.deviceForm = this.fb.group({
            serialNum: new FormControl('', Validators.required),
            modelNum: new FormControl(''),
            productId: new FormControl('', Validators.required),
            implantDate: new FormControl('', this.addValidatorsToImplantDate()),
            transmitter: new FormControl(''),
            search: new FormControl(''),
            leadChmbSettingCd: new FormControl(),
            implantPhyId: new FormControl(''),
            devChanged: new FormControl(''),
            editReason: new FormControl(''),
            implanterIds: new FormControl(''),
            dataMiningFlg: new FormControl(''),
        }));
    }

    removeNulls(obj: any): any {
        if (obj === '') {
            return null;
        }
        if (typeof obj === 'object') {
            for (let key in obj) {
                obj[key] = this.removeNulls(obj[key]);
            }
        }
        return obj;
    }

    assignLists() {
        this.assignedIds = [];
        this.avaliableIds = [];
        this.implantIds = [];
        this.patientDeviceData.dropdowns.clinicians.forEach((item) => {
            if (item.acctId === -1) {
                this.assignedIds.push(item);
            }
            if (
                this.patientDeviceData?.medTeam?.availableIds &&
                this.patientDeviceData.medTeam.availableIds.indexOf(
                    item.acctId
                ) !== -1
            ) {
                this.avaliableIds.push(item);
            }
            if (
                this.patientDeviceInfo?.implanterIds &&
                this.patientDeviceInfo.implanterIds.indexOf(item.acctId) !== -1
            ) {
                this.implantIds.push(item);
            }
        });
    }

    public handleEmailPhone(e) {
        this.toggleEmailPhoneConditionallyMandatory();
    }

    public toggleEmailPhoneConditionallyMandatory() {
        var isPhoneRequried = true;
        var isEmailRequired = true;

        var emailEmpty = String(this.patientDeviceForm.get('patientDetails').get('email').value ?? '').trim();
        var phoneNumberEmpty = String(this.patientDeviceForm.get('patientDetails').get('phone').get('phoneNum').value ?? '').trim();

        var isPrimaryPhoneMandatory = this.patientDeviceForm
            .get('directCallMsg')
            .get('callContactTypeCd').value;
        //Direct not enabled
        this.countryCd = this.addressDetails?.get('countryCd').value
        if (this.isICMCategory || this.isNGQCategory) {
            //ICM patient
            // if Clinic's country is US then phone number mandatory irrespective of Email.
            if ((this.countryCd == '140' || isPrimaryPhoneMandatory === 993 || isPrimaryPhoneMandatory === 994) && this.isICMCategory) {
                isEmailRequired = false;
                isPhoneRequried = true;
            }
            else if ((isPrimaryPhoneMandatory === 993 || isPrimaryPhoneMandatory === 994) && this.isNGQCategory) {
                isEmailRequired = false;
                isPhoneRequried = true;
            }
            else {
                if (phoneNumberEmpty && !emailEmpty) {
                    //Phone number present email optional
                    isEmailRequired = false;
                    // isPhoneRequried = true;
                } else if (!phoneNumberEmpty && emailEmpty) {
                    isPhoneRequried = false;
                }
                else if (!phoneNumberEmpty && !emailEmpty) {
                    isPhoneRequried = true;
                    isEmailRequired = true;
                } else if (phoneNumberEmpty && emailEmpty) {
                    isEmailRequired = false;
                    isPhoneRequried = false;
                }
                else if (emailEmpty && isPrimaryPhoneMandatory === 1304 || isPrimaryPhoneMandatory === 995) {
                    isPhoneRequried = false;
                }
            }
        }
        else if (isPrimaryPhoneMandatory == '993' || isPrimaryPhoneMandatory == '994') {
            //ICD patient
            isPhoneRequried = true;
            isEmailRequired = false;
        } else {
            isPhoneRequried = false;
            isEmailRequired = false;
        }

        const isPhoneRequiredExteranlly =
            this.enrollService.primaryPhoneRequired.getValue();
        if (isPhoneRequiredExteranlly && !this.isNGQCategory && !this.isICMCategory) {
            isPhoneRequried = true;
            isEmailRequired = false;
        }
        if (isPhoneRequried && isEmailRequired) {
            this.phoneValidations = true;
            this.emailValidations = true;
        }
        else if (isPhoneRequried) {
            // Add phone validations
            this.phoneValidations = true;
            // this.showPhysicianOpt = true;
            //this.emailValidations = false;
            if (
                !this.patientDeviceForm
                    .get('patientDetails')
                    .get('phone')
                    .get('countryCode').value
            ) {
                this.patientDeviceForm
                    .get('patientDetails')
                    .get('phone')
                    .get('countryCode')
                    .setErrors({ required: true });
            } else if (
                !this.patientDeviceForm
                    .get('patientDetails')
                    .get('phone')
                    .get('areaCode').value
            ) {
                if (this.countryCd === 140) {
                    this.patientDeviceForm
                        .get('patientDetails')
                        .get('phone')
                        .get('areaCode')
                        .setErrors({ required: true });
                } else {
                    this.patientDeviceForm
                        .get('patientDetails')
                        .get('phone')
                        .get('areaCode')
                        .setValue(null)
                    this.patientDeviceForm
                        .get('patientDetails')
                        .get('phone')
                        .get('areaCode')
                        .clearValidators();
                    this.phoneForm.get('areaCode').clearValidators();
                }
                // this.patientDeviceForm
                //     .get('patientDetails')
                //     .get('phone')
                //     .get('areaCode')
                //     .setErrors({ required: true });
            } else if (
                !this.patientDeviceForm
                    .get('patientDetails')
                    .get('phone')
                    .get('phoneNum').value
            ) {
                this.patientDeviceForm
                    .get('patientDetails')
                    .get('phone')
                    .get('phoneNum')
                    .setErrors({ required: true });
            }
            this.patientDeviceForm
                .get('patientDetails')
                .get('email')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('email')
                .updateValueAndValidity();
        } else {
            // Remove phone validations
            this.phoneValidations = false;
            this.showPhysicianOpt = false;
            this.emailValidations = false;
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('countryCode')
                .setValidators([
                    Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('areaCode')
                .setValidators([
                    Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('phoneNum')
                .setValidators([
                    Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
                ]);
        }
        this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('countryCode')
            .updateValueAndValidity();
        this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('areaCode')
            .updateValueAndValidity();
        this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('phoneNum')
            .updateValueAndValidity();
        // this.patientDeviceForm
        //     .get('patientDetails')
        //     .get('phone')
        //     .get('countryCode')
        //     .setValidators(Validators.pattern("^[0-9-.,()+' ']*$")); //^[0-9]*$
        // this.patientDeviceForm
        //     .get('patientDetails')
        //     .get('phone')
        //     .get('areaCode')
        //     .setValidators(Validators.pattern("^[0-9-.,()+' ']*$"));
        // this.patientDeviceForm
        //     .get('patientDetails')
        //     .get('phone')
        //     .get('phoneNum')
        //     .setValidators(Validators.pattern("^[0-9-.,()+' ']*$"));
        this.patientDeviceForm?.get('patientDetails').updateValueAndValidity();

        if (isEmailRequired) {
            //Add email validation
            this.emailValidations = true;
            this.patientDeviceForm
                .get('patientDetails')
                .get('email')
                .setValidators([
                    Validators.required,
                    Validators.pattern(
                        '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.+-]+.com$'
                    ),
                ]);
        } else {
            //remove email validation
            this.emailValidations = false;
            this.patientDeviceForm
                .get('patientDetails')
                .get('email')
                .clearValidators();
        }
        this.patientDeviceForm
            .get('patientDetails')
            .get('email').updateValueAndValidity();
        this.patientDeviceForm?.get('patientDetails').updateValueAndValidity();
        this.patientDeviceForm?.updateValueAndValidity();
    }

    public confirm(devData, saveOpt, emergency, existingpatientdata: any) {


        // Build model names string from existing patient data
        let existingModelNames = '';
        if (existingpatientdata?.patientDevices && Array.isArray(existingpatientdata.patientDevices)) {
            existingModelNames = existingpatientdata.patientDevices
                .map(device => this.getProductNameById(device?.productId))
                .filter(name => name) // Remove null/undefined values
                .join('/ ');
        }

        // Build model names string from devData
        let newModelNames = '';
        if (devData?.patientDevices && Array.isArray(devData.patientDevices)) {
            newModelNames = devData.patientDevices
                .map(device => this.getProductNameById(device?.productId))
                .filter(name => name) // Remove null/undefined values
                .join('/ ');
        }

        // Create the deviceInfo string
        const deviceInfo = `${existingModelNames}<br/><b>${this.translate('label.gb.to_lc','',
                                        ReturnType.HTML)}</b><br/>${newModelNames}`;

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '720px',
            data: {
                patient: this.patientDetailsForm.value,
                deviceInfo: deviceInfo,
                transmissionCount: this.transmissionCount,
                isLeadlessPacemaker: this.isLPCategory || this.isAveirDevice,
                techSupportDmrOnly : this.userProfile?.techSupportDmrOnly || false,
            },
        });
        return dialogRef.afterClosed().toPromise();
    }

    public updateDeviceData(
        devData,
        saveOpt,
        emergency: boolean = false,
        isFormModified: boolean = false,
        existingpatientdata?: any
    ) {
        this.isError = false;
        this.isAPIError = false;
        this.errorHeading = null;
        this.errorMsgs = [];
        this.patternError = [];
        this.dataMsgs = [];
        this.selectedAssignedIds = [];
        this.remainAvaliableIds = [];
        const patientDevice = this.enrollService.getPrimaryPatientDevice(devData);
        const patResDevice = this.enrollService.getPrimaryPatientDevice(this.patRes);
        if (isNaN(patientDevice?.serialNum)) {
            // return this.toasterService.error(
            //     this.translate('msg.pa825.text', '', ReturnType.HTML),
            // null,
            // {
            //     enableHtml: true,
            //     disableTimeOut: true,
            // }
            // );

            // const dialogConfig: PopupConfig = {
            //     type: PopupType.Prompt,
            //     message: this.translate('msg.pa825.text', '', ReturnType.HTML),
            //     confirmText:
            //         this.localizationService.generateLocalizedStr(
            //             'label.gb.ok'
            //         ),
            //     confirmId: this.identifierService.buttonId(
            //         'pcs-location-popup',
            //         'Ok'
            //     ),
            //     customPopup: true,
            // };
            // return this.popupService.open(dialogConfig);
            this.isSavebtnClick = false;
            this.isAPIError = true;
            this.toasterService.clear();
            return this.toasterService.error(
                this.localizationService.generateLocalizedStr(
                    'msg.pa825.text',
                    '',
                    ReturnType.HTML
                ),
                null,
                {
                    enableHtml: true,
                    disableTimeOut: false,
                    tapToDismiss: false,
                }
            );
        }
        if(this.patRes.patientDevices && this.patRes.patientDevices.length === 2 && this.patRes.patientDevices[0].serialNum == this.patRes.patientDevices[1].serialNum){
             this.isSavebtnClick = false;
            return this.toasterService.error(
                this.translate('msg.pa901.text', '', ReturnType.HTML),
                null,
                {
                        enableHtml: true,
                        disableTimeOut: true,
                        tapToDismiss: false,
                }
            );
        }

        const patientDevices: any[] = this.patRes?.patientDevices ?? [];
        const invalidSerialNums: any[] = [];
        for (const device of patientDevices) {
            const serialNum = device?.serialNum;
            const productId = device?.productId;
            const deviceEntry = this.patRes?.dropdowns?.devices?.find(dev => dev.value == productId);
            const serialNumValidationLow = deviceEntry?.serialNumValidationLow;
            const serialNumValidationHigh = deviceEntry?.serialNumValidationHigh;
            const isSerialNumValid =
                serialNum != null &&
                String(serialNum).length <= 9 &&
                /^[0-9]*$/.test(String(serialNum)) &&
                (serialNumValidationLow == null || Number(serialNum) >= Number(serialNumValidationLow)) &&
                (serialNumValidationHigh == null || Number(serialNum) <= Number(serialNumValidationHigh));

            if (!isSerialNumValid) {
                invalidSerialNums.push(serialNum);
            }
        }
        if (invalidSerialNums.length > 0) {
            this.isSavebtnClick = false;
            return this.userNotificationMessageAToaster({
                msgs: [{ msg: 'msg.pa825.text', data: this.isAveirDevice ? invalidSerialNums : [] }]
            });
        }

        if (patResDevice) {
            patResDevice.editReason = this.patientDeviceInfo?.editReason;
        }
        this.editReason = this.patientDeviceInfo?.editReason;
        devData = {
            ...devData,
            isFormModified: isFormModified,
        };
        if (devData?.patient) devData.patient.transmitterOrderFlg = this.orderTransmitter;
        if (
            this.functionMode === FunctionMode.PROFILE ||
            this.enrollService.isStepBackFromEnroll ||
            existingpatientdata
        ) {
            devData.actionMsg = this.patRes.actionMsg;
            devData.leads = this.patRes.leads;
            devData.medTeam = this.patRes.medTeam;
            if (devData?.patient) {
                if (devData.patient.address) devData.patient.address.addressId =
                    this.updateDevideInfo?.patient?.address?.addressId;
                devData.patient.customerApplPatientId =
                    this.patRes?.patient?.customerApplPatientId;
                devData.patient.deviceCheckFlg = this.patRes?.patient?.deviceCheckFlg;
                devData.patient.enableMedFlg = this.patRes?.patient?.enableMedFlg;
                devData.patient.lockoutPatientInitDcFlg =
                    this.patRes?.patient?.lockoutPatientInitDcFlg;
                devData.patient.lockoutPatientInitTransFlg =
                    this.patRes?.patient?.lockoutPatientInitTransFlg;
                devData.patient.patientStatusCd =
                    this.patRes?.patient?.patientStatusCd;
                // Use fresh GET response (existingpatientdata) when available, as patRes may be stale after emergency contact flow
                devData.patient.transmitterVolumeCd =
                    existingpatientdata?.patient?.transmitterVolumeCd ?? this.patRes?.patient?.transmitterVolumeCd;
                if (devData.patient.phone) devData.patient.phone.phoneId =
                    this.updateDevideInfo?.patient?.phone?.phoneId;
            }
            if (this.functionMode === 'profile' && patResDevice) {
                patResDevice.editReason = String(patResDevice.prevSerialNum) !== String(patResDevice.serialNum) ? null : patResDevice.editReason;
                patResDevice.editReason = String(patResDevice.productId) !== String(patResDevice.prevProductId) ? null : patResDevice.editReason;
                if ((patientDevice?.serialNum !== this.tempValSerial) ||
                    String(patientDevice?.productId) !== String(this.tempValModel)
                ) {
                    this.updatedDevice = false;
                }

                // Handle second device if present
                if (this.patRes.patientDevices && this.patRes.patientDevices.length > 1) {
                    const patResSecondDevice = this.patRes.patientDevices[1];
                    const secondDevice = devData.patientDevices && devData.patientDevices.length > 1 ? devData.patientDevices[1] : null;

                    if (patResSecondDevice && secondDevice) {
                        patResSecondDevice.editReason = String(patResSecondDevice.prevSerialNum) !== String(patResSecondDevice.serialNum) ? null : patResSecondDevice.editReason;
                        patResSecondDevice.editReason = String(patResSecondDevice.productId) !== String(patResSecondDevice.prevProductId) ? null : patResSecondDevice.editReason;
                        if ((secondDevice?.serialNum !== this.drtempValSerial) ||
                            String(secondDevice?.productId) !== String(this.drtempValModel)
                        ) {
                            this.updatedDevice = false;
                        }
                    }
                }
            }

            // Check if primary device has changed
            let primaryDeviceChanged = false;
            primaryDeviceChanged = patResDevice?.prevSerialNum && patResDevice?.prevSerialNum !== null &&
                patResDevice?.prevProductId && patResDevice?.prevProductId !== null &&
                !patResDevice?.editReason &&
                (String(patResDevice.prevSerialNum) !== String(patResDevice.serialNum) ||
                    String(patResDevice.prevProductId) !== String(patResDevice.productId));
            // Check if second device exists and has changed
            let secondDeviceChanged = false;
            if (this.patRes.patientDevices && this.patRes.patientDevices.length > 1) {
                const patResSecondDevice = this.patRes.patientDevices[1];
                secondDeviceChanged = patResSecondDevice?.prevSerialNum && patResSecondDevice?.prevSerialNum !== null &&
                   patResSecondDevice?.prevProductId && patResSecondDevice?.prevProductId !== null &&
                    !patResSecondDevice?.editReason &&
                    (String(patResSecondDevice.prevSerialNum) !== String(patResSecondDevice.serialNum) ||
                        String(patResSecondDevice.prevProductId) !== String(patResSecondDevice.productId));
            }

            // Check if second device is newly added or removed (SR→DR or DR→SR).
            // Use devData (form submission) vs existingpatientdata (server snapshot) so that
            // DR→DR edits (both have 2 devices) do not falsely trigger the device-change dialog.
            const newlyAddedOrRemovedSecondDevice = devData.patientDevices && devData.patientDevices.length != existingpatientdata.patientDevices.length;
            if (primaryDeviceChanged || secondDeviceChanged || newlyAddedOrRemovedSecondDevice) {
                let serialNum = this.deviceForm?.get('serialNum')?.value;
                let checkScenario ='';
                if(existingpatientdata?.patientDevices?.length==2  && devData?.patientDevices?.length==2) checkScenario='DRTODR';
                if(existingpatientdata?.patientDevices?.length==2  && devData?.patientDevices?.length==1) checkScenario='DRTOSR';
                if(existingpatientdata?.patientDevices?.length==1  && devData?.patientDevices?.length==2) checkScenario='SRTODR';
                if(existingpatientdata?.patientDevices?.length==1  && devData?.patientDevices?.length==1) checkScenario='SRTOSR';
                // Confirm and Save data on Device data change
                if (!this.updatedDevice) {
                    // if ((devData.patientDevices.serialNum !== this.tempValSerial) ||
                    // String(this.patRes.patientDevices.productId) !== String(this.patRes.patientDevices.prevProductId)
                    // ) {
                    this.confirm(devData, saveOpt, emergency,existingpatientdata).then(
                        (result) => {
                            if (result && result?.data !== 'cancel') {
                                this.isSavebtnClick = false;
                                this.tempValSerial = devData?.patientDevices?.[0]?.serialNum;
                                this.tempValModel = devData?.patientDevices?.[0]?.productId;
                                if (this.patientDeviceInfo) this.patientDeviceInfo.editReason =
                                    result.data;
                                this.updatedDevice = true;
                                this.editReason = result.data;
                                let imp_date = this.helperService.parseGMTDateTime(
                                            new Date(),
                                            false,
                                            false,
                                            this.userProfile?.clinicUserTZ,
                                            this.userProfile?.dateFormat,
                                            this.userProfile?.timeFormat,
                                            this.userProfile?.locale
                                        );

                                switch (checkScenario) {
                                    case 'DRTODR':
                                        this.drtempValSerial = devData?.patientDevices?.[1]?.serialNum;
                                        this.drtempValModel = devData?.patientDevices?.[1]?.productId;
                                        // Compare both device indices (0 and 1)
                                        const device0Changed =
                                            String(existingpatientdata?.patientDevices?.[0]?.serialNum) !== String(devData?.patientDevices?.[0]?.serialNum) ||
                                            String(existingpatientdata?.patientDevices?.[0]?.productId) !== String(devData?.patientDevices?.[0]?.productId);

                                        const device1Changed =
                                            String(existingpatientdata?.patientDevices?.[1]?.serialNum) !== String(devData?.patientDevices?.[1]?.serialNum) ||
                                            String(existingpatientdata?.patientDevices?.[1]?.productId) !== String(devData?.patientDevices?.[1]?.productId);

                                        // Update first device if changed
                                        if (device0Changed && devData?.patientDevices?.[0]) {
                                            devData.patientDevices[0].editReason = result.data;
                                            devData.patientDevices[0].devChanged = true;
                                            if (this.patRes.patientDevices && this.patRes.patientDevices[0]) {
                                                this.patRes.patientDevices[0].editReason = result.data;
                                                this.patRes.patientDevices[0].devChanged = true;
                                            }
                                        }

                                        // Update second device if changed
                                        if (device1Changed && devData?.patientDevices?.[1]) {
                                            devData.patientDevices[1].editReason = result.data;
                                            devData.patientDevices[1].devChanged = true;
                                            if (this.patRes.patientDevices && this.patRes.patientDevices[1]) {
                                                this.patRes.patientDevices[1].editReason = result.data;
                                                this.patRes.patientDevices[1].devChanged = true;
                                            }
                                        }
                                        // Handle implant date for first device
                                        if (
                                            (result.data === 'ChangeDevice') ||
                                            (result.data === 'CorrectDevice' && (this.patientDeviceForm.get('deviceData').get('implantDate').value == null || this.patientDeviceForm.get('deviceData').get('implantDate').value == ''))
                                        ) {
                                            this.patientDeviceForm.get('deviceData').get('implantDate').setValue(imp_date);
                                            if (devData?.patientDevices?.[0]) devData.patientDevices[0].implantDate = imp_date;
                                            if (this.patRes?.patientDevices?.[0]) this.patRes.patientDevices[0].implantDate = imp_date;
                                        }

                                        // Handle implant date for second device (DR device)
                                        if (
                                            (result.data === 'ChangeDevice') ||
                                            (result.data === 'CorrectDevice' && (this.patientDeviceForm.get('deviceData').get('drImplantDate').value == null || this.patientDeviceForm.get('deviceData').get('drImplantDate').value == ''))
                                        ) {
                                            this.patientDeviceForm.get('deviceData').get('drImplantDate').setValue(imp_date);
                                            if (devData?.patientDevices?.[1]) devData.patientDevices[1].implantDate = imp_date;
                                            if (this.patRes?.patientDevices?.[1]) this.patRes.patientDevices[1].implantDate = imp_date;
                                        }

                                        break;

                                    case 'DRTOSR':
                                        // Dual to Single: Check if the new single device's serialNum+productId
                                        // exists in ANY of the existing devices array entries.
                                        // If it exists → device was retained unchanged (no edit reason needed).
                                        // If it does NOT exist → device is new/changed (set editReason + devChanged).
                                        const newSingleSerial = String(devData?.patientDevices?.[0]?.serialNum);
                                        const newSingleProductId = String(devData?.patientDevices?.[0]?.productId);

                                        const deviceExistsInExisting = existingpatientdata?.patientDevices?.some(
                                            (existingDev: any) =>
                                                String(existingDev?.serialNum) === newSingleSerial &&
                                                String(existingDev?.productId) === newSingleProductId
                                        ) ?? false;

                                        const drToSrDeviceChanged = !deviceExistsInExisting;
                                        // Update the single device only if it's not found in the existing array
                                        if (drToSrDeviceChanged && devData?.patientDevices?.[0]) {
                                            devData.patientDevices[0].editReason = result.data;
                                            devData.patientDevices[0].devChanged = true;
                                            if (this.patRes.patientDevices && this.patRes.patientDevices[0]) {
                                                this.patRes.patientDevices[0].editReason = result.data;
                                                this.patRes.patientDevices[0].devChanged = true;
                                            }
                                        } else{
                                            if (devData?.patientDevices?.[0]) {
                                                devData.patientDevices[0].devChanged = false;
                                                devData.patientDevices[0].editReason = result.data;
                                            }
                                            if (this.patRes.patientDevices && this.patRes.patientDevices[0]) {
                                                this.patRes.patientDevices[0].devChanged = false;
                                                this.patRes.patientDevices[0].editReason = result.data;
                                            }
                                        }
                                        // Handle implant date for single device
                                        if (
                                            (result.data === 'ChangeDevice') ||
                                            (result.data === 'CorrectDevice' && (this.patientDeviceForm.get('deviceData').get('implantDate').value == null || this.patientDeviceForm.get('deviceData').get('implantDate').value == ''))
                                        ) {
                                            this.patientDeviceForm.get('deviceData').get('implantDate').setValue(imp_date);
                                            if (devData?.patientDevices?.[0]) devData.patientDevices[0].implantDate = imp_date;
                                            if (this.patRes?.patientDevices?.[0]) this.patRes.patientDevices[0].implantDate = imp_date;
                                        }
                                         // Handle implant date for second device (DR device)
                                        if (
                                            (result.data === 'ChangeDevice') ||
                                            (result.data === 'CorrectDevice' && (this.patientDeviceForm.get('deviceData').get('drImplantDate').value == null || this.patientDeviceForm.get('deviceData').get('drImplantDate').value == ''))
                                        ) {
                                            this.patientDeviceForm.get('deviceData').get('drImplantDate').setValue(imp_date);
                                            if (devData?.patientDevices?.[1]) devData.patientDevices[1].implantDate = imp_date;
                                            if (this.patRes?.patientDevices?.[1]) this.patRes.patientDevices[1].implantDate = imp_date;
                                        }
                                        break;

                                    case 'SRTODR':
                                        this.drtempValSerial = devData?.patientDevices?.[1]?.serialNum;
                                        this.drtempValModel = devData?.patientDevices?.[1]?.productId;
                                        // Single to Dual: Compare existing single device with new dual devices
                                        const srToDrDevice0Changed =
                                            String(existingpatientdata?.patientDevices?.[0]?.serialNum) !== String(devData?.patientDevices?.[0]?.serialNum) ||
                                            String(existingpatientdata?.patientDevices?.[0]?.productId) !== String(devData?.patientDevices?.[0]?.productId);

                                        // Second device is new, so it's always changed
                                        const srToDrDevice1IsNew = (devData?.patientDevices?.length ?? 0) > 1;

                                        // Update first device if changed
                                        if (srToDrDevice0Changed && devData?.patientDevices?.[0]) {
                                            devData.patientDevices[0].editReason = result.data;
                                            devData.patientDevices[0].devChanged = true;
                                            if (this.patRes.patientDevices && this.patRes.patientDevices[0]) {
                                                this.patRes.patientDevices[0].editReason = result.data;
                                                this.patRes.patientDevices[0].devChanged = true;
                                            }
                                        }

                                        // Update second device as it's new
                                        if (srToDrDevice1IsNew && devData?.patientDevices?.[1]) {
                                            devData.patientDevices[1].editReason = result.data;
                                            devData.patientDevices[1].devChanged = true;
                                            if (this.patRes.patientDevices && this.patRes.patientDevices[1]) {
                                                this.patRes.patientDevices[1].editReason = result.data;
                                                this.patRes.patientDevices[1].devChanged = true;
                                            }
                                        }

                                        // Handle implant date for first device
                                        if (
                                            (result.data === 'ChangeDevice') ||
                                            (result.data === 'CorrectDevice' && (this.patientDeviceForm.get('deviceData').get('implantDate').value == null || this.patientDeviceForm.get('deviceData').get('implantDate').value == ''))
                                        ) {
                                            this.patientDeviceForm.get('deviceData').get('implantDate').setValue(imp_date);
                                            if (devData?.patientDevices?.[0]) devData.patientDevices[0].implantDate = imp_date;
                                            if (this.patRes?.patientDevices?.[0]) this.patRes.patientDevices[0].implantDate = imp_date;
                                        }

                                        // Handle implant date for second device (DR device)
                                        if (
                                            (result.data === 'ChangeDevice') ||
                                            (result.data === 'CorrectDevice' && (this.patientDeviceForm.get('deviceData').get('drImplantDate').value == null || this.patientDeviceForm.get('deviceData').get('drImplantDate').value == ''))
                                        ) {
                                            this.patientDeviceForm.get('deviceData').get('drImplantDate').setValue(imp_date);
                                            if (devData?.patientDevices?.[1]) devData.patientDevices[1].implantDate = imp_date;
                                            if (this.patRes?.patientDevices?.[1]) this.patRes.patientDevices[1].implantDate = imp_date;
                                        }

                                        break;

                                    case 'SRTOSR':
                                        // Single to Single: Compare existing single device with new single device
                                        const srToSrDeviceChanged =
                                            String(existingpatientdata?.patientDevices?.[0]?.serialNum) !== String(devData?.patientDevices?.[0]?.serialNum) ||
                                            String(existingpatientdata?.patientDevices?.[0]?.productId) !== String(devData?.patientDevices?.[0]?.productId);

                                        // Update device if changed
                                        if (srToSrDeviceChanged && devData?.patientDevices?.[0]) {
                                            devData.patientDevices[0].editReason = result.data;
                                            devData.patientDevices[0].devChanged = true;
                                            if (this.patRes.patientDevices && this.patRes.patientDevices[0]) {
                                                this.patRes.patientDevices[0].editReason = result.data;
                                                this.patRes.patientDevices[0].devChanged = true;
                                            }
                                        }

                                        // Handle implant date for single device
                                        if (
                                            (result.data === 'ChangeDevice') ||
                                            (result.data === 'CorrectDevice' && (this.patientDeviceForm.get('deviceData').get('implantDate').value == null || this.patientDeviceForm.get('deviceData').get('implantDate').value == ''))
                                        ) {
                                            this.patientDeviceForm.get('deviceData').get('implantDate').setValue(imp_date);
                                            if (devData?.patientDevices?.[0]) devData.patientDevices[0].implantDate = imp_date;
                                            if (this.patRes?.patientDevices?.[0]) this.patRes.patientDevices[0].implantDate = imp_date;
                                        }
                                        break;

                                    default:
                                }
                            } else if (!result || result?.data == 'cancel') {
                                this.isSavebtnClick = false;
                                this.toggleEmergencyCont = false;
                                this.callingEmergencyCont = false;
                            }
                        }
                    );
                }
                else {
                    // Only update editReason for primary device if serial number or productId has changed
                    if (existingpatientdata?.patientDevices?.[0] && devData.patientDevices[0]) {
                       // devData.patientDevices[0].leadChmbSettingCd = existingpatientdata.patientDevices[0]?.leadChmbSettingCd;
                        devData.patientDevices[0].patientDeviceId = existingpatientdata.patientDevices[0]?.patientDeviceId;
                        devData.patientDevices[0].prevPatientDeviceId = existingpatientdata.patientDevices[0]?.prevPatientDeviceId;
                        devData.patientDevices[0].prevProductId = existingpatientdata.patientDevices[0]?.prevProductId;
                        devData.patientDevices[0].prevSerialNum = existingpatientdata.patientDevices[0]?.prevSerialNum;
                        if (this.patRes.patientDevices && this.patRes.patientDevices[0]) {
                           // this.patRes.patientDevices[0].leadChmbSettingCd = existingpatientdata.patientDevices[0]?.leadChmbSettingCd;
                            this.patRes.patientDevices[0].patientDeviceId = existingpatientdata.patientDevices[0]?.patientDeviceId;
                            this.patRes.patientDevices[0].prevPatientDeviceId = existingpatientdata.patientDevices[0]?.prevPatientDeviceId;
                            this.patRes.patientDevices[0].prevProductId = existingpatientdata.patientDevices[0]?.prevProductId;
                            this.patRes.patientDevices[0].prevSerialNum = existingpatientdata.patientDevices[0]?.prevSerialNum;
                        }
                        if(checkScenario=='DRTOSR') {
                            const newSingleSerial = String(devData?.patientDevices?.[0]?.serialNum);
                            const newSingleProductId = String(devData?.patientDevices?.[0]?.productId);

                            const deviceExistsInExisting = existingpatientdata?.patientDevices?.some(
                                (existingDev: any) =>
                                    String(existingDev?.serialNum) === newSingleSerial &&
                                    String(existingDev?.productId) === newSingleProductId
                            ) ?? false;

                            const drToSrDeviceChanged = !deviceExistsInExisting;
                            if(drToSrDeviceChanged) {
                                if (devData?.patientDevices?.[0]) devData.patientDevices[0].editReason = this.editReason;
                                this.toggleEmergencyCont = false;
                            }else{
                                const matchedDevice = existingpatientdata?.patientDevices?.find(
                                    (existingDev: any) =>
                                        String(existingDev?.serialNum) === newSingleSerial &&
                                        String(existingDev?.productId) === newSingleProductId
                                );
                                if (devData?.patientDevices?.[0]) {
                                    devData.patientDevices[0].devChanged = false;
                                    devData.patientDevices[0].editReason = this.editReason;
                                    devData.patientDevices[0].patientDeviceId = matchedDevice?.patientDeviceId;
                                    devData.patientDevices[0].prevPatientDeviceId = matchedDevice?.prevPatientDeviceId;
                                    devData.patientDevices[0].prevSerialNum = matchedDevice?.prevSerialNum;
                                    devData.patientDevices[0].prevProductId = matchedDevice?.prevProductId;
                                }
                            }
                        }else{
                            const device0Changed =
                                String(existingpatientdata?.patientDevices?.[0]?.serialNum) !== String(devData?.patientDevices?.[0]?.serialNum) ||
                                String(existingpatientdata?.patientDevices?.[0]?.productId) !== String(devData?.patientDevices?.[0]?.productId);
                                if (device0Changed && devData?.patientDevices?.[0]) {
                                    devData.patientDevices[0].editReason = this.editReason;
                                    this.toggleEmergencyCont = false;
                                } else{
                                    if (devData?.patientDevices?.[0]) {
                                        devData.patientDevices[0].devChanged = false;
                                    if(checkScenario=='SRTODR') devData.patientDevices[0].editReason = null; // In single to dual scenario, if primary device is not changed, then edit reason should be null as both devices are new
                                    }
                                }
                        }
                    }
                    if ( existingpatientdata?.patientDevices?.[1] && devData.patientDevices[1]) {
                       // devData.patientDevices[1].leadChmbSettingCd = existingpatientdata.patientDevices[1]?.leadChmbSettingCd;
                        devData.patientDevices[1].patientDeviceId = existingpatientdata.patientDevices[1]?.patientDeviceId;
                        devData.patientDevices[1].prevPatientDeviceId = existingpatientdata.patientDevices[1]?.prevPatientDeviceId;
                        devData.patientDevices[1].prevProductId = existingpatientdata.patientDevices[1]?.prevProductId;
                        devData.patientDevices[1].prevSerialNum = existingpatientdata.patientDevices[1]?.prevSerialNum;
                        if (this.patRes.patientDevices && this.patRes.patientDevices[1]) {
                            //this.patRes.patientDevices[1].leadChmbSettingCd = existingpatientdata.patientDevices[1]?.leadChmbSettingCd;
                            this.patRes.patientDevices[1].patientDeviceId = existingpatientdata.patientDevices[1]?.patientDeviceId;
                            this.patRes.patientDevices[1].prevPatientDeviceId = existingpatientdata.patientDevices[1]?.prevPatientDeviceId;
                            this.patRes.patientDevices[1].prevProductId = existingpatientdata.patientDevices[1]?.prevProductId;
                            this.patRes.patientDevices[1].prevSerialNum = existingpatientdata.patientDevices[1]?.prevSerialNum;
                        }
                        const device1Changed =
                            String(existingpatientdata?.patientDevices?.[1]?.serialNum) !== String(devData?.patientDevices?.[1]?.serialNum) ||
                            String(existingpatientdata?.patientDevices?.[1]?.productId) !== String(devData?.patientDevices?.[1]?.productId);
                        if (device1Changed) {
                            if(devData?.patientDevices?.[1]){
                                devData.patientDevices[1].editReason = this.editReason;
                            }
                            this.toggleEmergencyCont = false;
                        } else{
                            if(devData?.patientDevices?.[1]) {
                                devData.patientDevices[1].devChanged = false;
                            }
                        }
                    }

                    const newlyAdded = this.patRes?.patientDevices && this.patRes.patientDevices.length > (existingpatientdata?.patientDevices?.length ?? 0);
                    if (newlyAdded && devData?.patientDevices?.[1]) {
                        const device1Changed =
                            String(existingpatientdata?.patientDevices?.[1]?.serialNum) !== String(devData?.patientDevices?.[1]?.serialNum) ||
                            String(existingpatientdata?.patientDevices?.[1]?.productId) !== String(devData?.patientDevices?.[1]?.productId);
                        devData.patientDevices[1].editReason = this.editReason;
                        if (device1Changed) {
                            this.toggleEmergencyCont = false;
                        } else {
                            devData.patientDevices[1].devChanged = false;
                        }
                    }
                    this.saveDeviceData(devData, saveOpt, emergency);

                }

            } else {
                if (devData?.patientDevices?.[0]?.editReason || devData?.patientDevices?.[1]?.editReason) {
                    if(devData?.patientDevices?.length==1){
                        if (devData?.patientDevices?.[0] && existingpatientdata?.patientDevices?.[0]) {
                           // devData.patientDevices[0].leadChmbSettingCd = existingpatientdata.patientDevices[0]?.leadChmbSettingCd;
                            devData.patientDevices[0].patientDeviceId = existingpatientdata.patientDevices[0]?.patientDeviceId;
                            devData.patientDevices[0].prevPatientDeviceId = existingpatientdata.patientDevices[0]?.prevPatientDeviceId;
                            devData.patientDevices[0].prevProductId = existingpatientdata.patientDevices[0]?.prevProductId;
                            devData.patientDevices[0].prevSerialNum = existingpatientdata.patientDevices[0]?.prevSerialNum;
                            if (this.patRes.patientDevices && this.patRes.patientDevices[0]) {
                              //  this.patRes.patientDevices[0].leadChmbSettingCd = existingpatientdata.patientDevices[0]?.leadChmbSettingCd;
                                this.patRes.patientDevices[0].patientDeviceId = existingpatientdata.patientDevices[0]?.patientDeviceId;
                                this.patRes.patientDevices[0].prevPatientDeviceId = existingpatientdata.patientDevices[0]?.prevPatientDeviceId;
                                this.patRes.patientDevices[0].prevProductId = existingpatientdata.patientDevices[0]?.prevProductId;
                                this.patRes.patientDevices[0].prevSerialNum = existingpatientdata.patientDevices[0]?.prevSerialNum;
                            }
                        }
                    }
                } else {
                    // Save data on edit -No device data change
                    if (devData?.patientDevices?.[0]) {
                        devData.patientDevices[0].devChanged = false;
                        devData.patientDevices[0].editReason = null;
                    }
                    if (devData?.patientDevices?.[1]) {
                        devData.patientDevices[1].devChanged = false;
                        devData.patientDevices[1].editReason = null;
                    }
                }
                this.saveDeviceData(devData, saveOpt, emergency);
            }
        } else if (this.functionMode === FunctionMode.ENROLL) {
            // Save data on enroll
            if (devData?.patientDevices?.[0]) devData.patientDevices[0].devChanged = false;
            if (devData?.patientDevices?.[1]) devData.patientDevices[1].devChanged = false;
            this.route.params.subscribe((res) => {
                if (
                    res?.id
                ) {
                    this.enrollService.patientId.next(res.id);
                    this.getEnrollPatientsFunc(
                        res.id,
                        (data) => {
                            if (data?.patient) {
                                devData.patient.address.addressId =
                                    data.patient.address.addressId;
                                devData.patient.phone.phoneId =
                                    data.patient.phone.phoneId;
                                devData.patient.deviceCheckFlg =
                                    data.patient.deviceCheckFlg;
                                devData.patient.enableMedFlg =
                                    data.patient.enableMedFlg;
                                devData.patient.lockoutPatientInitDcFlg =
                                    data.patient.lockoutPatientInitDcFlg;
                                devData.patient.lockoutPatientInitTransFlg =
                                    data.patient.lockoutPatientInitTransFlg;
                                devData.patient.patientStatusCd =
                                    data.patient.patientStatusCd;
                                devData.patient.transmitterVolumeCd =
                                    data.patient.transmitterVolumeCd;
                                devData.patient.customerApplPatientId =
                                    data.patient.customerApplPatientId;
                            }
                            // Handle patientDevices array
                            const devDataDevice = this.enrollService.getPrimaryPatientDevice(devData);
                            const dataDevice = this.enrollService.getPrimaryPatientDevice(data);
                            if (devDataDevice && dataDevice) {
                                devDataDevice.leadChmbSettingCd = dataDevice.leadChmbSettingCd;
                                devDataDevice.patientDeviceId = dataDevice.patientDeviceId;
                                devDataDevice.prevPatientDeviceId = dataDevice.prevPatientDeviceId;
                                devDataDevice.prevProductId = dataDevice.prevProductId;
                                devDataDevice.prevSerialNum = dataDevice.prevSerialNum;
                            }
                            this.saveDeviceData(devData, saveOpt, emergency);
                        },
                        (err) => {
                            if (err && err.actionErrors) {
                                this.showToaster(err.actionErrors);
                            } else {
                                this.helperService.showErrorToastr(err);
                            }
                        }
                    );
                } else {
                    this.saveDeviceData(devData, saveOpt, emergency);
                }
            });
        }
    }


    saveDeviceData(devData, saveOpt, emergency) {
        this.isSavebtnClick = false;
        this.toasterService.clear();
        // const locationsIds = this.dropDownInfo.locations.filter(
        //     (item) => Number(item.value) === devData.patient.locationId
        // );
        // devData.patient.address.city = (locationsIds?.length) ? locationsIds[0].label : '';
        devData?.medTeam?.assigned?.map((data) => {
            if (data?.id == -1) {
                devData.patient.notifyOnCallPosition = data.order;
            }
        });
        const payload = {
            ...devData,
            patient: {
                ...devData.patient,
                patientNum: devData.patient.patientNum !== '' && devData.patient.patientNum !== null ? devData.patient.patientNum : null,
                address: {
                    ...devData?.patient?.address,
                    zipCode: devData?.patient?.address?.countryCd == '140' ? devData?.patient?.address?.zipCode?.replace(
                        /[^0-9]/g,
                        ''
                    ) : devData?.patient?.address?.zipCode,
                },
            },
        };

        this.getUpdateDeviceDataFunc(
                payload,
                this.functionMode,
                this.patientid,
                (res) => {
                    if (this.editReason !== null && this.editReason === 'CorrectDevice') {
                        this.transmissionDetailService.setWebsiteNotificationId(null);
                    }
                    if (this.rpCapableFlg && this.editReason !== null) {
                        const programmingSessionStateCd = PROG_STATE_FAIL_CD;
                        let programmingFailureReasonCd;
                        programmingFailureReasonCd = this.editReason === 'ChangeDevice' ? DVCCALRT : DVCDCALRT;
                        const res$ = this.patientDeviceInfo['patientRpCapableFlg'] ? this.enrollService.updatePatientProfile(this.patientDeviceInfo.patientDeviceId,
                            { programmingSessionStateCd, programmingFailureReasonCd }).pipe(catchError((err) => of(true))) : of({});
                        return res$.pipe(map((_) => res));
                    } else {
                        return of(res); // Return the original response if icmDeviceAvailable is false
                    }
                },
                (res) => this.saveDeviceDataSuccess(emergency, res, saveOpt),
                (err) => {
                    this.isAPIError = true;
                    this.enrollService.updateDeviceFormDirty(false);
                    this.callingEmergencyCont = false;
                    this.toggleEmergencyCont = false;
                    if (emergency) {
                        this.isConfirmClick = false;
                        this.enrollService.openEmergencyDialog(false);
                    }
                    this.enrollService.showEmergencyContactPopup.next(false);
                    if (err.fields) {
                        if (
                            err.fields.includes('number') ||
                            err.fields.includes('areaCode') ||
                            err.fields.includes('countryCode')
                        ) {
                            setTimeout(() => {
                                this.patientDeviceForm
                                    ?.get('patientDetails')
                                    ?.get('phone')
                                    ?.get('countryCode')
                                    .setErrors({ pattern: true });
                                this.patientDeviceForm
                                    ?.get('patientDetails')
                                    ?.get('phone')
                                    ?.get('areaCode')
                                    .setErrors({ pattern: true });
                                this.patientDeviceForm
                                    ?.get('patientDetails')
                                    ?.get('phone')
                                    ?.get('phoneNum')
                                    .setErrors({ pattern: true });
                            }, 700)

                        }
                    }
                    if (err?.msgs && err?.msgs?.length > 0) {
                        if (err?.fields) {
                            this.highlightErrorFields(err.fields);
                        }
                        let params;
                        let error;
                        if (err?.msgs[0]?.childs) {
                            params = err?.msgs[0]?.childs.map((child) => {
                                return this.translate(
                                    child.msg,
                                    {
                                        0: this.translate(
                                            err?.msgs?.[0]?.childs?.[1]?.childs?.[0]?.msg ??
                                            err?.msgs[0]?.childs[2]?.childs[0]?.msg,
                                            {},
                                            ReturnType.HTML
                                        ),
                                        1: this.translate(
                                            err?.msgs[0]?.childs[1]?.msg,
                                            {},
                                            ReturnType.HTML
                                        ),
                                    },
                                    ReturnType.HTML
                                );
                            });

                            error = this.translate(
                                err?.msgs[0]?.msg,
                                { '0': params.join('<br/>') },
                                'html'
                            );
                        } else {
                            error = this.translate(
                                err?.msgs[0]?.msg.replace(
                                    /(<br\s*[\/]?>)|(&lt;br\s*[\/]?&gt;)/gi,
                                    '\n'
                                ),
                                '',
                                'html'
                            );
                        }

                        if (err?.msgs[0]?.msg == 'msg.pa874.text') {
                            this.isSavebtnClick = false;
                            return this.toasterService.show(
                                this.localizationService.generateLocalizedStr(
                                    err?.msgs[0]?.msg,
                                    '',
                                    ReturnType.HTML
                                ),
                                null,
                                {
                                    enableHtml: true,
                                    tapToDismiss: false,
                                    disableTimeOut: false,
                                    toastClass: `${ToasterClass.userNotificationMessageA} ${ToasterClass.ngxToastr}`,
                                }
                            );
                        }

                        if (err?.msgs[0]?.msg == 'msg.pa901.text' || err?.msgs[0]?.msg == 'msg.pa854a.text') {
                            return this.userNotificationMessageAToaster(
                               err
                            );
                        }

                        if (err?.msgs[0].msg == 'msg.cs818.text') {
                            err?.msgs[0].childs.forEach((data) => {
                                if (data.msg === 'label.gb.between') {
                                    this.patientDeviceForm
                                        .get('directCallMsg')
                                        .get('msgStartTime')
                                        .setErrors({ invalid: true });
                                }
                                if (data.msg === 'label.gb.and') {
                                    this.patientDeviceForm
                                        .get('directCallMsg')
                                        .get('msgEndTime')
                                        .setErrors({ invalid: true });
                                }
                            });
                        }

                        if (err?.msgs[0]?.msg == 'msg.pa825.text') {
                            this.isSavebtnClick = false;
                            return this.toasterService.error(
                                this.localizationService.generateLocalizedStr(
                                    'msg.pa825.text',
                                    '',
                                    ReturnType.HTML
                                ),
                                null,
                                {
                                    enableHtml: true,
                                    tapToDismiss: false,
                                    disableTimeOut: true,
                                }
                            );
                        }
                        if (err?.msgs[0]?.msg == 'msg.pa904.text') {
                            this.deviceForm.markAsDirty();
                            this.deviceForm.updateValueAndValidity();
                            let origialSerial = this.patRes?.patientDevices?.[0]?.prevSerialNum;
                            if (String(origialSerial) !== this.deviceForm.get('serialNum').value) {
                                this.updatedDevice = false;
                                this.patientDeviceInfo.editReason = null;
                                devData.patientDevices.editReason = null;
                                this.patRes.patientDevices.editReason = null;
                            }
                            return this.userNotificationMessageAToaster(
                               err
                            );
                        }
                        this.isSavebtnClick = false;
                        this.toasterService.error(error, '', {
                            enableHtml: true,
                            disableTimeOut: true,
                            tapToDismiss: false,
                        });
                        if (this.functionMode == 'enroll') {
                            this.setDisplayMode(FunctionMode.ENROLL);
                            this.enrollService.patientId.next('');
                        }
                    }
                }
            );
    }

    private saveDeviceDataSuccess(emergency: any, res: any, saveOpt: any) {
        this.setDeviceData.emit(res);
        this.isSavebtnClick = false;
        if (emergency) {
            this.enrollService.openEmergencyDialog(true);
        }
        this.patientDeviceForm.markAsPristine();
        this.isAPIError = false;
        let emrContactOpening = this.toggleEmergencyCont;
        this.enrollService.updateDeviceFormDirty(false);
        let showFormEditMode;
        if ((this.functionMode == 'profile' &&
            this.displayMode == 'edit') ||
            this.functionMode == 'enroll') {
            showFormEditMode = true && this.toggleEmergencyCont;
            //  this.enrollService.showEmergencyContactPopup.next(true);
        }
        this.transmissionDetailService.setPatDataUpdate();
        this.spinnerSer.visibility = false;
        this.updatedDevice = false;
        this.toggleEmergencyCont = false;
        if (this.functionMode !== 'enroll') {
            this.callingEmergencyCont = false;
        }
        this.enrollService.showEmergencyContactPopup.next(false);
        if (res?.patient) {
            this.enrollService.patientId.next(
                res.patient.patientId
            );
            if (!(this.functionMode == 'enroll') &&
                this.functionMode == 'profile' &&
                this.displayMode == 'edit' &&
                !this.callingEmergencyCont)
                if (showFormEditMode) {
                    //  if(!emergency)
                    //   {  this.setDisplayMode('view'); }
                    this.setDisplayMode('edit');
                } else {
                    this.setDisplayMode('view');
                }
        }
        if (this.callingEmergencyCont) {
            this.enrollService.countryCd =
                this.userInfo.clinicCountryCd;
            this.countryCd = this.userInfo.clinicCountryCd;
            this.callingEmergencyCont = false;
        } else {
            this.toggleEmergencyCont = false;
            this.enrollService.showEmergencyContactPopup.next(
                false
            );
            this.getPatientId.emit(res.patient.patientId);
            if (this.cancelledCM819) {
                this.makeEmergencyContactPopupFalse();
            }
            if (saveOpt) {
                this.navigateToTrans.emit('next');
            } else {

                this.navigateToTrans.emit('save-close');
            }
        }
        if (this.functionMode == FunctionMode.PROFILE &&
            this.displayMode !== 'enroll') {
            if (!emrContactOpening) {
                let msg = this.localizationService.generateLocalizedStr(
                    'msg.cs830.text',
                    null,
                    'html'
                );
                // this.toasterService.success(msg);
                this.isSavebtnClick = false;
                this.toasterService.show(msg, null, {
                    enableHtml: true,
                    toastClass: `${ToasterClass.userNotificationMessageB} ${ToasterClass.ngxToastr}`,
                });
            }
        }
        if (!this.callingEmergencyCont) {
            this.getDeviceData(emergency);
        }
        this.patientDeviceInfo.editReason = null;
        this.patRes.patientDevices.devChanged = false;
        this.patientDeviceInfo.prevProductId =
            this.patRes.patientDevices.productId;
        this.patientDeviceInfo.prevSerialNum =
            res.patientDevices.serialNum;
        if (!emergency) {
            this.setDisplayMode(FunctionMode.VIEW);
        }
        this.tempValSerial = undefined;
        this.tempValModel = undefined;
        this.drtempValSerial = undefined;
        this.drtempValModel = undefined;
    }

    userNotificationMessageAToaster(err) {
        this.isSavebtnClick = false;
        if (err?.msgs[0]?.data && Array.isArray(err.msgs[0].data) && err.msgs[0].data.length > 0) {
                                const serialNumbers = err.msgs[0].data.join(',');
                                const customMessage =this.localizationService.generateLocalizedStr(
                                    err?.msgs[0]?.msg,
                                    '',
                                    ReturnType.HTML
                                    )+ `<br/><br/>`+this.localizationService.generateLocalizedStr(
                                                                'label.gb.serial_number',
                                                                    '',
                                                                ReturnType.HTML
                                    )+': ' +`${serialNumbers}`;
                                return this.toasterService.show(
                                    customMessage,
                                    null,
                                    {
                                        enableHtml: true,
                                        toastClass: `${ToasterClass.userNotificationMessageA} ${ToasterClass.ngxToastr}`,
                                    }
                                );
                            }
        return this.toasterService.error(
            this.localizationService.generateLocalizedStr(
                err?.msgs[0]?.msg,
                '',
                ReturnType.HTML
            ),
            null,
            {
                enableHtml: true,
                tapToDismiss: false,
                disableTimeOut: true
            }
        );
    }

    highlightErrorFields(errorData) {
        errorData.forEach((key) => {
            key = key == 'number' ? 'phoneNum' : key;
            this.patientDeviceForm
                ?.get('patientDetails')
                ?.get('phone')
                ?.get(key)
                ?.markAsUntouched();
        });
        if (errorData?.length) {
            errorData.forEach((field) => {
                field = field == 'number' ? 'phoneNum' : field;
                this.patientDeviceForm
                    ?.get('patientDetails')
                    ?.get('phone')
                    ?.get(field)
                    ?.setErrors({ incorrect: true });
                if(field=='msgEndTime' || field=='msgStartTime'){
                    this.patientDeviceForm?.get('directCallMsg')?.get(field)?.setErrors({ invalid: true });
                }
            });
            this.patientDeviceForm.markAllAsTouched();
            errorData.forEach((key) => {
                this.patientDetailsForm?.get(key)?.markAsUntouched();
            });
            if (errorData?.length) {
                errorData.forEach((field) => {
                    if (field == 'zipCode') {
                        this.addressDetails
                            .get(field)
                            ?.setErrors({ incorrect: true });
                        this.addressDetails.markAllAsTouched();
                    } else if (field == 'implantDate') {
                        (
                            this.patientDeviceForm?.get(
                                'deviceData'
                            ) as FormGroup
                        ).controls['implantDate'].setErrors({
                            incorrect: true,
                        });
                    } else {
                        this.patientDetailsForm
                            ?.get(field)
                            ?.setErrors({ incorrect: true });
                    }
                });
                this.patientDetailsForm.markAllAsTouched();
            }
        }
    }

    public buildPatientDetails() {
        let dRegex =
            this.userProfile?.dateFormat == 'dd-MM-yyyy'
                ? this.ddMMDateRegex
                : this.userProfile?.dateFormat == 'yyyy-MM-dd'
                    ? this.yyMMddRegex
                    : this.dateRegex;
        return (this.patientDetailsForm = this.fb.group({
            patientId: new FormControl(
                this.defaultPatientDetails !== undefined ? '-1' : '',
                Validators.required
            ),
            // patientNum: new FormControl('', Validators.required)
            firstName: new FormControl(
                this.defaultPatientDetails?.firstName ?? '',
                Validators.required
            ),
            middleName: new FormControl(''),
            lastName: new FormControl(
                this.defaultPatientDetails?.lastName ?? '',
                Validators.required
            ),
            altFirstName: new FormControl(''),
            altLastName: new FormControl(''),
            genderCd: new FormControl(
                this.defaultPatientDetails?.genderCd ?? ''
            ),
            dateOfBirthStr: new FormControl(
                this.defaultPatientDetails?.dateOfBirthStr ?? '',
                [Validators.required, Validators.pattern(dRegex)]
            ),
            raceCd: new FormControl(''),
            patientNum: new FormControl(''),
            locationId: new FormControl(''),
            languageCd: new FormControl(''),
            enrollmentDate: new FormControl(''),
            raceConsentFlg: new FormControl(''),
            transmitterOrderFlg: new FormControl(''),
            dataMiningFlg: new FormControl(''),
            merlinNetId: new FormControl(''),
            address: this.buildAddressGroup(),
            phone: this.buildMainPhoneGroup(),
            email: new FormControl(''),
            clinicEnv: new FormControl(''),
            dateOfBirth: new FormControl(''),
            notifyOnCallFlg: new FormControl(''),
            notifyOnCallPosition: new FormControl(''),
            customerApplPatientId: new FormControl(''),
            deviceCheckFlg: new FormControl(''),
            lockoutPatientInitTransFlg: new FormControl(''),
            lockoutPatientInitDcFlg: new FormControl(''),
            enableMedFlg: new FormControl(''),
            transmitterVolumeCd: new FormControl(''),
            patientStatusCd: new FormControl(''),
            givenNames: new FormControl(
                this.defaultPatientDetails?.givenNames ?? ''
            ),
            usedGivenName: new FormControl(
                this.defaultPatientDetails?.usedGivenName ?? ''
            ),
            usedLastName: new FormControl(
                this.defaultPatientDetails?.usedLastName ?? ''
            ),
            insNumber: new FormControl(
                this.defaultPatientDetails?.insNumber ?? ''
            ),
            oidNumber: new FormControl(
                this.defaultPatientDetails?.oidNumber ?? ''
            ),
            placeOfBirth: new FormControl(
                this.defaultPatientDetails?.placeOfBirth ?? ''
            ),
            franceSsn: new FormControl(
                this.defaultPatientDetails?.franceSsn ?? ''
            ),
        }));
    }

    public callMethodChange(change) {
        if (this.isICMCategory || this.isNGQCategory) {
            this.toggleEmailPhoneConditionallyMandatory();
        }
        if (change === '993' || change === '994') {
            this.phoneValidations = true;
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('countryCode')
                .setValidators([
                    Validators.required,
                    Validators.pattern("^[0-9-.,()+' ']*$"),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('areaCode')
                .setValidators([
                    Validators.required,
                    Validators.pattern("^[0-9-.,()+' ']*$"),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('phoneNum')
                .setValidators([
                    Validators.required,
                    Validators.pattern("^[0-9-.,()+' ']*$"),
                ]);
        } else {
            this.phoneValidations = false;
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('countryCode')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('areaCode')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('phoneNum')
                .clearValidators();
        }
        if (change == '995') {
            this.medicalOnCallSel = true;
            this.messageForm.addControl(
                'patientCallSMS',
                new FormControl('', Validators.required)
            );
        } else {
            this.medicalOnCallSel = false;
            this.messageForm.removeControl('patientCallSMS');
            this.messageForm.clearValidators();
        }
        this.messageForm?.get('patientCallSMS')?.updateValueAndValidity();
        this.patientDeviceForm?.get('patientDetails')?.updateValueAndValidity();
    }

    public onMsgReminderFlgChange(value: any) {
        this.msgReminderFlgValue = value;
    }

    public onMsgOverdueFlgChange(value: any) {
        this.msgOverdueFlgValue = value;
    }

    public buildAddressGroup() {
        return (this.addressDetails = this.fb.group({
            addressId: new FormControl(''),
            address: new FormControl(''),
            address2: new FormControl(''),
            address3: new FormControl(''),
            city: new FormControl(''),
            state: new FormControl(''),
            stateCd: new FormControl(''),
            countryCd: new FormControl(''),
            zipCode: new FormControl('', [
                Validators.maxLength(30) ///^[0-9]*$/
            ]),
        }));
    }

    public buildMainPhoneGroup() {
        return (this.phoneForm = this.fb.group({
            countryCode: new FormControl(
                this.defaultPatientDetails?.phone?.countryCode ?? '',
                [Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/))]
            ),
            areaCode: new FormControl('', [
                Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
            ]),
            phoneNum: new FormControl('', [
                Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
            ]),
            phoneId: new FormControl(''),
        }));
    }

    public buildDirectCallMsg() {
        return (this.messageForm = this.fb.group({
            callContactTypeCd: new FormControl(),
            msgEndAmpm: new FormControl(),
            msgEndTime: new FormControl(),
            msgOverdueFlg: new FormControl(),
            msgReminderFlg: new FormControl(),
            msgStartAmpm: new FormControl(),
            msgStartTime: new FormControl(''),
            patientCallSMS: new FormControl(),
        }));
    }

    public togglePhysicianOpt(e) {
        let productId = "";
        if (e) {
            // extracting information from event
            if (typeof e === 'object') {
                this.clinicDetailsInfo = e.currentValue?.clinicDetails;
                e = e.currentValue?.patientDevices?.[0]?.productId?.toString();
            }
            const lpOpt = this.clinicDetailsInfo
                ? this.clinicDetailsInfo.avrProdIds
                    ? this.clinicDetailsInfo.avrProdIds.split(',')
                    : null
                : null;
            const icmOpt = this.clinicDetailsInfo
                ? this.clinicDetailsInfo.icmProdIds
                    ? this.clinicDetailsInfo.icmProdIds.split(',')
                    : null
                : null;
            const ngqOpt = this.clinicDetailsInfo
                ? this.clinicDetailsInfo.ngqProdIds
                    ? this.clinicDetailsInfo.ngqProdIds.split(',')
                    : null
                : null;
            // const unityOpt = this.clinicDetailsInfo
            //     ? this.clinicDetailsInfo.unityProdIds
            //         ? this.clinicDetailsInfo.unityProdIds.split(',')
            //         : null
            //     : null;
            if (lpOpt && lpOpt.indexOf(e) > -1) {
                // this.showPhysicianOpt = true;  this is required for LP category to show physician option
                this.isLPCategory = true;
                this.isICMCategory = false;
                this.isNGQCategory = false;
            } else {
                this.isLPCategory = false;
            }
            if (icmOpt && icmOpt.indexOf(e) > -1) {
                this.toggleEmailPhoneConditionallyMandatory();
                // this.showPhysicianOpt = true;
                this.isICMCategory = true;
                this.isNGQCategory = false;
                this.isLPCategory = false;
            } else {
                this.isICMCategory = false;
                this.showPhysicianOpt = false;
            }
            if (ngqOpt && ngqOpt.indexOf(e) > -1) {
                this.toggleEmailPhoneConditionallyMandatory();
                // this.showPhysicianOpt = true;
                this.isICMCategory = false;
                this.isNGQCategory = true;
                this.isUnityCategory = false;
                this.isLPCategory = false;
            } else {
                // this.showPhysicianOpt = false;
                this.isNGQCategory = false;
            }
            // Update isAveirDevice based on the selected product code
            this.isAveirDevice = this.aveirAllCodes.has(String(e));

            if (!this.isICMCategory && !this.isNGQCategory && !this.showPhysicianOpt) {
                this.toggleEmailPhoneConditionallyMandatory();
            }
            // unityOpt && unityOpt.indexOf(e) > -1 ?
            //     (this.showPhysicianOpt = false, this.isUnityCategory = true)
            //     : (this.isUnityCategory = false);
            // this.toggleEmailPhoneConditionallyMandatory();
            if (!this.isICMCategory) {
                const implantPhyIdCtrl = this.patientDeviceForm?.get('deviceData')?.get('implantPhyId');
                const implantPhyIdNameCtrl = this.deviceForm?.get('implantPhyIdName');

                if (implantPhyIdCtrl) {
                    implantPhyIdCtrl.clearValidators();
                    implantPhyIdCtrl.setErrors(null);
                    implantPhyIdCtrl.updateValueAndValidity();
                }

                if (implantPhyIdNameCtrl) {
                    implantPhyIdNameCtrl.clearValidators();
                    implantPhyIdNameCtrl.setErrors(null);
                    implantPhyIdNameCtrl.updateValueAndValidity();
                }
            }

            this.updateAddressValidations();
        }
    }

    public avaliableIdListFun(e) {
        this.remainAvaliableIds = [];
        e &&
            e.forEach((element) => {
                this.remainAvaliableIds.push(element.acctId);
            });
    }

    public assignedIdListFun(e) {
        this.selectedAssignedIds = [];
        e.forEach((i, ind) => {
            let temp = {
                order: 0,
                id: -1,
            };
            temp.id = i.acctId;
            temp.order = ind + 1;
            this.selectedAssignedIds.push(temp);
        });
    }

    /**
     * Updates address field validations based on device category and country
     */
    private updateAddressValidations() {
        if (!this.patientDeviceForm || !this.addressDetails) return;

        // Use loose equality to handle both string '140' and number 140
        const isUSA = this.addressDetails?.get('countryCd')?.value == CountryCdEnum.USA;
        let addressFieldsRequired = false;

        const transmitterOrdered = this.deviceForm?.get('transmitter')?.value ?? this.orderTransmitter;

        if (isUSA) {
            if (this.isICMCategory || this.isNGQCategory || this.isLPCategory || this.isAveirDevice) {
                addressFieldsRequired = true;
            }
            else if (transmitterOrdered) {
                addressFieldsRequired = true;
            }
        }

        this.showAddrValidations = addressFieldsRequired;

        const addressGroup = this.patientDeviceForm.get('patientDetails')?.get('address');
        if (!addressGroup) return;

        if (addressFieldsRequired) {
            addressGroup.get('state')?.clearValidators();
            addressGroup.get('address')?.setValidators([Validators.required]);
            addressGroup.get('city')?.setValidators([Validators.required]);
            addressGroup.get('stateCd')?.setValidators([Validators.required]);
            addressGroup.get('zipCode')?.setValidators([
                Validators.required,
                Validators.pattern(
                    new RegExp(/^([^\d]*\d){5}(-?([^\d]*\d){4})?[^\d]*$/)
                ),
            ]);
            addressGroup.get('countryCd')?.setValidators([Validators.required]);
        } else {
            addressGroup.get('address')?.clearValidators();
            addressGroup.get('city')?.clearValidators();
            addressGroup.get('stateCd')?.clearValidators();
            addressGroup.get('state')?.clearValidators();
            addressGroup.get('countryCd')?.clearValidators();
            addressGroup.get('zipCode')?.setValidators([Validators.pattern(new RegExp(/^[0-9]*$/))]);
        }

        // Update validity for all address fields
        addressGroup.get('address')?.updateValueAndValidity();
        addressGroup.get('city')?.updateValueAndValidity();
        addressGroup.get('stateCd')?.updateValueAndValidity();
        addressGroup.get('state')?.updateValueAndValidity();
        addressGroup.get('zipCode')?.updateValueAndValidity();
        addressGroup.get('countryCd')?.updateValueAndValidity();
    }

    public transmitterSelect(change) {
        this.orderTransmitter = change;
        this.updateAddressValidations();
    }

    public cancel() {
        if (
            this.patientDeviceForm.dirty ||
            this.deviceForm.dirty ||
            this.addressDetails.dirty ||
            this.messageForm.dirty ||
            this.phoneForm.dirty
        ) {
            let msg = this.translate('msg.cs834.text', '', 'html');
            // const dialogConfig: PopupConfig = {
            //     type: PopupType.Confirm,
            //     message: msg,
            //     confirmText: this.translate('label.gb.ok', {}, ReturnType.HTML),
            //     confirmId: this.identifierService.buttonId(
            //         'pcs-location-popup',
            //         'ok'
            //     ),
            //     cancelId: this.identifierService.buttonId(
            //         'pcs-location-popup',
            //         'cancel001'
            //     ),
            //     cancelText: this.translate(
            //         'label.gb.button_cancel',
            //         {},
            //         ReturnType.HTML
            //     ),
            //     customPopup: true,
            // };
            //this.popupService.open(dialogConfig);
            // this.popupService.dialogRef
            //     .afterClosed()
            //     .subscribe((response: any) => {
            //         if (response) {
            /**
             * PCN00039896 - Data Correction
             * Resetting below data when user clicks on cancel button,
             * Will show Data Correction popup from next time
             */

            this.updatedDevice = false;
            this.tempValModel = undefined;
            this.tempValSerial = undefined;
            this.drtempValModel = undefined;
            this.drtempValSerial = undefined;
            //------------------------------
            // if (this.functionMode === FunctionMode.ENROLL) {
            //     this.router.navigate(['patient-list']);
            // } else {
            this.patientDeviceForm.markAsPristine();
            this.deviceForm.markAsPristine();
            this.addressDetails.markAsPristine();
            this.messageForm.markAsPristine();
            this.phoneForm.markAsPristine();
            this.getDeviceData();
            this.displayMode = FunctionMode.VIEW;
            this.setParentDisplayMode(FunctionMode.VIEW);
            // }
            this.enrollService.updateDeviceFormDirty(false);
            // }
            //});
        } else {
            if (this.functionMode === FunctionMode.ENROLL) {
                this.router.navigate(['patient-list']);
            } else {
                this.displayMode = FunctionMode.VIEW;
                this.setParentDisplayMode(FunctionMode.VIEW);
                this.getDeviceData();
            }
            this.enrollService.updateDeviceFormDirty(false);
        }
    }

    public save() {
        // this.toasterService.clear();
        this.makeEmergencyContactPopupFalse();
        if (this.functionMode === 'profile' && this.displayMode === 'edit') {
            if (
                !(
                    this.patientDeviceForm.dirty ||
                    this.deviceForm.dirty ||
                    this.addressDetails.dirty ||
                    this.messageForm.dirty ||
                    this.phoneForm.dirty ||
                    (this.implantPhyId != '' || this.implantPhyId != null)
                ) &&
                !this.isError
            ) {
                this.setDisplayMode('view');
                return;
            }
        }
        let rawFormData = this.patientDeviceForm.getRawValue();
        this.transmissionDetailService.updateDevice(
            {
                isDeviceChange: true,
                devName: rawFormData?.deviceData?.productName?.label,
                patFirstName: rawFormData?.patientDetails?.firstName,
                patLastName: rawFormData?.patientDetails?.lastName,
                patientNum: rawFormData?.patientDetails?.patientNum
            });
        this.continue(false, true);
    }

    public checkInsInfo(isSaveClick, isContinueClick, emergency: boolean = false) {
        if (!this.isSavebtnClick) {
            this.isSavebtnClick = true;
            this.isSaveClick = isSaveClick;
            this.isContinueClick = isContinueClick;
            if (this.prevInsNumber != this.patientDeviceForm.get('patientDetails').get('insNumber').value)
                this.isConfirmClick = false;
            if (this.patientDeviceForm.get('patientDetails').get('insNumber').value && this.patientDeviceForm
                .get('patientDetails')
                .get('insNumber').value != '' && this.patientDeviceForm.get('patientDetails').get('insNumber').dirty && this.patientDeviceForm.get('patientDetails').get('insNumber').value != -1 && !this.isConfirmClick) {
                this.prevInsNumber = this.patientDeviceForm.get('patientDetails').get('insNumber').value;
                this.getEnrollPatientByInsFunc(
                        this.patientDeviceForm.get('patientDetails').get('insNumber').value.toString(),
                        (patientDeviceData: PatientDeviceDataModel) => {
                            this.patientData = patientDeviceData;
                            if (patientDeviceData?.isValidInsNumber) {
                                this.openDialog().then((result) => {
                                    if (result.isClickConfirm && emergency) {
                                        this.continue(true, emergency);
                                    }
                                })
                            }
                            else {
                                this.patientDeviceForm
                                    .get('patientDetails')
                                    .get('insNumber').reset();
                                this.isSavebtnClick = false;
                                 return this.toasterService.error(
                                            this.localizationService.generateLocalizedStr(
                                                'msg.pat_cannot_enroll.text',
                                                '',
                                                ReturnType.HTML
                                            ),
                                            null,
                                            {
                                                enableHtml: true,
                                                tapToDismiss: false,
                                                disableTimeOut: true
                                            }
                                    );
                            }
                        },
                        (err) => {
                            this.helperService.showErrorToastr(err);
                            this.isSavebtnClick = false;
                        }
                    );

            } else if (this.isEnrollByIns) {
                if (isContinueClick)
                    this.continue(true);
                if (isSaveClick)
                    this.save();
                if (emergency)
                    this.continue(false, emergency);

            } else if (emergency) {
                this.continue(false, emergency);
            }
            else {
                if (this.isSaveClick)
                    this.save();
                if (this.isContinueClick)
                    this.continue(true)
            }
        }
    }

    public continue(saveOpt, emergency: boolean = false) {
        this.deviceForm = this.patientDeviceForm?.get('deviceData') as FormGroup;
        const ngqOpt = this.clinicDetailsInfo
            ? this.clinicDetailsInfo.ngqProdIds
                ? this.clinicDetailsInfo.ngqProdIds.split(',')
                : null
            : null;
        let e = this.deviceForm?.get('productId').value
        if (ngqOpt && ngqOpt.indexOf(e?.toString()) > -1) {
            this.isICMCategory = false;
            this.isNGQCategory = true;
        }
        // Update isAveirDevice based on current product selection
        this.isAveirDevice = this.aveirAllCodes.has(String(e));
        this.toggleEmailPhoneConditionallyMandatory();
        this.clearErrorStates();

        const serialNumber = this.deviceForm.get('serialNum').value
        if (
            serialNumber &&
            !isNaN(serialNumber) &&
            !String(serialNumber).includes('.')
        ) {
            this.deviceForm
                .get('serialNum')
                .setValue(parseInt(serialNumber, 10));
        } else if (serialNumber) {
            this.deviceForm.get('serialNum').setValue(serialNumber);
        } else {
            this.deviceForm.get('serialNum').setValue('');
        }

        // Validate DR serial number if DR device is enabled
        if (this.deviceForm.get('drDevice')?.value && this.deviceForm.get('drSerialNum')) {
            const drSerialNumber = this.deviceForm.get('drSerialNum').value;
            if (
                drSerialNumber &&
                !isNaN(drSerialNumber) &&
                !String(drSerialNumber).includes('.')
            ) {
                this.deviceForm
                    .get('drSerialNum')
                    .setValue(parseInt(drSerialNumber, 10));
            } else if (drSerialNumber) {
                this.deviceForm.get('drSerialNum').setValue(drSerialNumber);
            } else {
                this.deviceForm.get('drSerialNum').setValue('');
            }
        }

        let countryCode = this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('countryCode');

        let areaCode = this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('areaCode');

        let phoneNumber = this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('phoneNum');

        countryCode.setErrors(null);
        areaCode.setErrors(null);
        phoneNumber.setErrors(null);
        countryCode.clearValidators();
        areaCode.clearValidators();
        phoneNumber.clearValidators();
        countryCode.updateValueAndValidity();
        areaCode.updateValueAndValidity();
        phoneNumber.updateValueAndValidity();
        if ((this.isNGQCategory || this.isICMCategory) && (this.phoneValidations && this.emailValidations)) {
            // if(this.phoneValidations && this.emailValidations){
            countryCode.markAsDirty();
            areaCode.markAsDirty();
            phoneNumber.markAsDirty();

            countryCode.setValidators([
                Validators.required,
                Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
            ]);

            phoneNumber.setValidators([
                Validators.required,
                Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
            ]);

            if (countryCode.value == '1') {
                areaCode.setValidators([
                    Validators.required,
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
            } else {
                areaCode.setValidators([
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
            }

            if (!countryCode.value || !areaCode.value || !phoneNumber.value) {
                if (this.countryCd === 140) {
                    areaCode.setValidators([
                        Validators.required,
                    ]);
                    areaCode.setErrors({ required: true });
                    areaCode.markAsDirty();
                } else {
                    areaCode.clearValidators();
                    areaCode.updateValueAndValidity();
                }
                countryCode.setErrors({ required: true });
                phoneNumber.setErrors({ required: true });
                countryCode.markAsDirty();
                phoneNumber.markAsDirty();
                countryCode.updateValueAndValidity();
                areaCode.updateValueAndValidity();
                phoneNumber.updateValueAndValidity();
            }
        } else if (
            this.patientDeviceForm.get('directCallMsg').get('callContactTypeCd')
                .value == '993' ||
            this.patientDeviceForm.get('directCallMsg').get('callContactTypeCd')
                .value == '994'
        ) {
            countryCode.markAsDirty();
            areaCode.markAsDirty();
            phoneNumber.markAsDirty();

            countryCode.setValidators([
                Validators.required,
                Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
            ]);

            phoneNumber.setValidators([
                Validators.required,
                Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
            ]);

            if (countryCode.value == '1') {
                areaCode.setValidators([
                    Validators.required,
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
            } else {
                areaCode.setValidators([
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
            }

            if (!countryCode.value || !areaCode.value || !phoneNumber.value) {
                countryCode.setErrors({ required: true });
                areaCode.setErrors({ required: true });
                phoneNumber.setErrors({ required: true });
                countryCode.markAsDirty();
                areaCode.markAsDirty();
                phoneNumber.markAsDirty();
            }
            countryCode.updateValueAndValidity();
            areaCode.updateValueAndValidity();
            phoneNumber.updateValueAndValidity();
            this.medicalOnCallSel = false;
            this.messageForm.removeControl('patientCallSMS');
            this.messageForm.clearValidators();
        } else if (this.patientDeviceForm.get('directCallMsg').get('callContactTypeCd')
            .value == '995' || this.patientDeviceForm.get('directCallMsg').get('callContactTypeCd')
                .value == '1304') {
            if (this.patientDeviceForm.get('directCallMsg').get('callContactTypeCd')
                .value == '995') {
                this.medicalOnCallSel = true;
                this.messageForm.addControl(
                    'patientCallSMS',
                    new FormControl('', Validators.required)
                );
            } else {
                this.medicalOnCallSel = false;
                this.messageForm.removeControl('patientCallSMS');
                this.messageForm.clearValidators();
            }
            var isPrimaryPhoneMandatory = this.patientDeviceForm
                .get('directCallMsg')
                .get('callContactTypeCd').value;
            if ((countryCode.value || areaCode.value || phoneNumber.value) && this.isICMCategory) {
                countryCode.markAsDirty();
                areaCode.markAsDirty();
                phoneNumber.markAsDirty();

                countryCode.setValidators([
                    Validators.required,
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
                if (this.isICMCategory && this.countryCd !== 140 && this.emailValidations && (isPrimaryPhoneMandatory === 1304 || isPrimaryPhoneMandatory === 995)) {
                    this.phoneValidations = false;
                    phoneNumber.setValidators([
                        Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                    ]);
                } else {
                    phoneNumber.setValidators([
                        Validators.required,
                        Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                    ]);
                }
                if (countryCode.value == '1') {
                    areaCode.setValidators([
                        Validators.required,
                        Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                    ]);
                } else {
                    areaCode.setValidators([
                        Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                    ]);
                }
            } else {
                countryCode.setValidators([
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
                phoneNumber.setValidators([
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
                areaCode.setValidators([
                    Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                ]);
            }
            countryCode.updateValueAndValidity();
            areaCode.updateValueAndValidity();
            phoneNumber.updateValueAndValidity();
            if (!this.isNGQCategory && !this.isICMCategory) {
                countryCode.setErrors(null);
                areaCode.setErrors(null);
                phoneNumber.setErrors(null);
                countryCode.clearValidators();
                areaCode.clearValidators();
                phoneNumber.clearValidators();
                countryCode.updateValueAndValidity();
                areaCode.updateValueAndValidity();
                phoneNumber.updateValueAndValidity();
            }
        }
        if (this.userInfo.clinicCountryCd === CountryCdEnum.USA && this.isICMCategory) {
            const implantPhyIdCtrl = this.patientDeviceForm.get('deviceData').get('implantPhyId');
            const implantPhyIdNameCtrl = this.deviceForm?.get('implantPhyIdName');
            const currentPhysicianId = implantPhyIdCtrl.value;

            // Always set required for ICM + US clinic
            implantPhyIdCtrl.setValidators(Validators.required);
            implantPhyIdCtrl.markAsDirty();

            if (currentPhysicianId && currentPhysicianId !== '') {
                implantPhyIdCtrl.setErrors(null);
                if (implantPhyIdNameCtrl) {
                    implantPhyIdNameCtrl.setErrors(null);
                }
            }

            implantPhyIdCtrl.updateValueAndValidity();
        } else {
            const implantPhyIdCtrl = this.patientDeviceForm?.get('deviceData')?.get('implantPhyId');
            const implantPhyIdNameCtrl = this.deviceForm?.get('implantPhyIdName');

            if (implantPhyIdCtrl) {
                implantPhyIdCtrl.clearValidators();
                implantPhyIdCtrl.setErrors(null);
                implantPhyIdCtrl.updateValueAndValidity();
            }

            if (implantPhyIdNameCtrl) {
                implantPhyIdNameCtrl.clearValidators();
                implantPhyIdNameCtrl.setErrors(null);
                implantPhyIdNameCtrl.updateValueAndValidity();
            }
        }

        this.formErrorHandling();

        const implantDateInput = this.patientDeviceForm
            .get('deviceData')
            .get('implantDate');
        const birthDateInput = this.patientDeviceForm
            .get('patientDetails')
            .get('dateOfBirthStr');

        if (!this.isError) {
            if (
                implantDateInput.value &&
                this.helperService.getDateInYMDFormat(implantDateInput.value, this.dateLabel) <=
                this.helperService.getDateInYMDFormat(birthDateInput.value, this.dateLabel)
            ) {
                let msg = this.localizationService.generateLocalizedStr(
                    'msg.pa859.text',
                    null,
                    'html'
                );
                this.isSavebtnClick = false;
                this.toasterService.error(msg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
                return false;
            }
        }

        if (!this.phoneForm.invalid) {
            const areCode = this.patientDeviceForm
                ?.get('patientDetails')
                ?.get('phone')
                ?.get('areaCode')
                ?.value?.replace(/[^0-9]/g, '');
            const countryCode = this.patientDeviceForm
                ?.get('patientDetails')
                ?.get('phone')
                ?.get('countryCode')
                ?.value?.replace(/[^0-9]/g, '');
            const number = this.patientDeviceForm
                ?.get('patientDetails')
                ?.get('phone')
                ?.get('phoneNum')
                ?.value?.replace(/[^0-9]/g, '');
            this.patientDeviceForm
                ?.get('patientDetails')
                ?.get('phone')
                ?.get('areaCode')
                .setValue(areCode);
            this.patientDeviceForm
                ?.get('patientDetails')
                ?.get('phone')
                ?.get('countryCode')
                .setValue(countryCode);
            this.patientDeviceForm
                ?.get('patientDetails')
                ?.get('phone')
                .get('phoneNum')
                .setValue(number);
        }
        this.phoneForm.updateValueAndValidity();

        if (!this.isError) {
            this.updateDevideInfo.clinicDetails = this.removeNulls(
                this.patientDeviceData?.clinicDetails
            );
            this.updateDevideInfo.medTeam = this.removeNulls(
                this.patientDeviceData?.medTeam
            );
            this.updateDevideInfo.messaging = this.removeNulls(
                this.patientDeviceData?.messaging
            );
            this.updateDevideInfo.patient = this.removeNulls(
                this.patientDeviceData.patient
            );
            // Use patientDevices array format for API
            const deviceData = this.removeNulls(this.patientDeviceData.patientDevices?.[0]);
            this.updateDevideInfo.patientDevices = deviceData ? [deviceData] : [{}];
            this.assignFormValues();
            // this.updateDevideInfo.patientDevices.leadChmbSettingCd = 1;
            this.enrollService.patientId.subscribe((patientID) => {
                if (patientID) {
                    this.updateDevideInfo.patient.patientId =
                        parseInt(patientID);
                    this.patientid = patientID;
                    this.setParentPatientid(patientID);
                } else {
                    this.patientid = -1;
                    this.setParentPatientid(-1);
              }
            });
            if (this.updateDevideInfo.patient.patientId != -1) {
                if (!this.enrollService.isStepBackFromEnroll && window.location.href.includes('patient-profile')) {
                    this.functionMode = FunctionMode.PROFILE;
                }
            }
            if (
                this.updateDevideInfo.patient.patientId != -1 || this.functionMode === FunctionMode.PROFILE ||
                this.enrollService.isStepBackFromEnroll
            ) {
                setTimeout(() => {
                    this.checkFormUpdated(saveOpt, emergency);
                }, 800)
            } else {
                this.updateDeviceData(
                    this.updateDevideInfo,
                    saveOpt,
                    emergency
                );
            }
        } else {
            this.patientDeviceForm.markAllAsTouched();
        }
    }

    clearErrorStates() {
        this.clearInvalidErrorState('directCallMsg', 'msgStartTime');
        this.clearInvalidErrorState('directCallMsg', 'msgEndTime');
    }

    clearInvalidErrorState(formGroup: string, formControl: string) {
        if (
            this.patientDeviceForm.get(formGroup).get(formControl)?.errors
                ?.invalid
        ) {
            this.patientDeviceForm
                .get(formGroup)
                .get(formControl)
                .setErrors({ invalid: false });
            this.patientDeviceForm
                .get(formGroup)
                .get(formControl)
                .updateValueAndValidity();
        }
    }

    updateStateValidators() {
        let country = this.addressDetails.get('countryCd').value;
        if (country == 140) {
            this.addressDetails.get('state').setValue(null);
            this.addressDetails.get('state').clearValidators();
        } else {
            this.addressDetails.get('stateCd').setValue(null);
            this.addressDetails.get('stateCd').clearValidators();
        }
    }
    formErrorHandling() {
        this.isError = false;
        if (this.viewMode() == true && this.profileMode()) {
            return;
        }
        this.errorHeading = null;
        this.errorMsgs = [];
        this.patternError = [];
        this.updateStateValidators();
        this.updateAddressValidations();

        // Preserve valid physician selection before form validation
        const implantPhyIdCtrl = this.deviceForm?.get('implantPhyId');
        const implantPhyIdNameCtrl = this.deviceForm?.get('implantPhyIdName');
        const hasValidPhysician = implantPhyIdCtrl?.value && implantPhyIdCtrl.value !== '';

        // Clear physician errors if valid ID exists (before marking form as dirty)
        if (hasValidPhysician && implantPhyIdNameCtrl) {
            implantPhyIdCtrl.setErrors(null);
            implantPhyIdNameCtrl.setErrors(null);
        }

        if (this.isICMCategory || this.isLPCategory) {
            this.handleImplatPhyIdInput();
        }

        this.patientDeviceForm.markAsDirty()
        // Always validate phone fields for invalid characters before checking form validity.
        const phonePattern = /^[0-9\(\).,+\- ]*$/;
        const ccCtrl = this.patientDeviceForm.get('patientDetails')?.get('phone')?.get('countryCode');
        const acCtrl = this.patientDeviceForm.get('patientDetails')?.get('phone')?.get('areaCode');
        const pnCtrl = this.patientDeviceForm.get('patientDetails')?.get('phone')?.get('phoneNum');
        const ccVal = ccCtrl?.value ?? '';
        const acVal = acCtrl?.value ?? '';
        const pnVal = pnCtrl?.value ?? '';
        [[ccCtrl, ccVal], [acCtrl, acVal], [pnCtrl, pnVal]].forEach(([ctrl, val]: any) => {
            if (val && !phonePattern.test(val)) {
                ctrl?.setErrors({ ...(ctrl.errors || {}), pattern: true });
                ctrl?.markAsTouched();
            }
        });

        if (this.patientDeviceForm.invalid) {
            this.isError = true;
            for (let item in this.deviceForm.controls) {
                if (item == 'implantPhyId') {
                    // Only validate if physician is required (ICM + US clinic) AND no valid physician ID exists
                    if ((this.isICMCategory || this.isLPCategory) && !hasValidPhysician) {
                        this.errorHandling(
                            this.deviceForm.controls[item],
                            item
                        );
                    }
                } else if (item == 'leadChmbSettingCd') {
                    this.errorHandling(this.deviceForm.controls[item], item);
                } else if (
                    (item == 'productId' || item == 'productName') &&
                    this.errorMsgs.includes('Device Name')
                ) {
                } else if (item == 'serialNum') {
                    this.errorHandling(this.deviceForm.controls[item], item);
                } else if (item == 'implantPhyIdName') {
                    // Skip validation if physician is not required or valid physician ID exists
                    if ((this.isICMCategory || this.isLPCategory) && !hasValidPhysician) {
                        this.errorHandling(this.deviceForm.controls[item], item);
                    }
                // Add DR device field validation for msg.cs818.text errors
                } else if (item == 'drSerialNum' || item == 'drProductId' || item == 'drProductName') {
                    // Only validate DR fields if DR device checkbox is checked
                    if (this.deviceForm.get('drDevice')?.value) {
                        this.errorHandling(this.deviceForm.controls[item], item);
                    }
                } else {
                    this.errorHandling(this.deviceForm.controls[item], item);
                }
            }
            for (let item in this.patientDetailsForm.controls) {
                this.errorHandling(
                    this.patientDetailsForm.controls[item],
                    item
                );
            }
            if (this.addressDetails.invalid) {
                for (let item in this.addressDetails.controls) {
                    if (
                        item === 'state' &&
                        this.addressDetails.controls[item].value
                    ) {
                        this.addressDetails.controls[
                            'stateCd'
                        ].clearValidators();
                        this.addressDetails.controls['state'].setErrors({});
                        this.addressDetails.controls[
                            'stateCd'
                        ].updateValueAndValidity();
                        this.addressDetails.controls[
                            'state'
                        ].updateValueAndValidity();
                    }
                    this.errorHandling(
                        this.addressDetails.controls[item],
                        item
                    );
                }
            }
            for (let item in this.phoneForm.controls) {
                this.errorHandling(this.phoneForm.controls[item], item);
            }
            for (let item in this.messageForm.controls) {
                this.errorHandling(this.messageForm.controls[item], item);
            }
            let errorMsg;
            if (this.errorMsgs?.length) {
                this.errorMsgs = this.errorMsgs.map((errKey) => {
                    return this.translate(errKey, {}, ReturnType.HTML);
                });
                //errorMsg = this.helperService.getErrorList(this.errorMsgs);
            }
            let ispatternMsg = false;
            if(this.patternError?.length && this.patternError?.includes(this.translate('label.gb.doc_perform_implant', {}, ReturnType.Text))){ 
                ispatternMsg = true;
            }
            if (this.errorMsgs.length == 0) {
                if (this.patternError?.length) {
                    ispatternMsg = true;
                    if (
                        this.patternError.includes(this.translate('label.gb.date_of_birth', {}, ReturnType.Text)) ||
                        this.patternError.includes(this.translate('label.gb.implant_date', {}, ReturnType.Text))
                    ) {
                        let index = this.patternError.includes(this.translate('label.gb.date_of_birth', {}, ReturnType.Text))
                            ? this.patternError.indexOf(this.translate('label.gb.date_of_birth', {}, ReturnType.Text))
                            : this.patternError.indexOf(this.translate('label.gb.implant_date', {}, ReturnType.Text));
                        this.patternError.splice(
                            index + 1,
                            0,
                            this.translate(
                                'msg.cs816.text_appendix',
                                {
                                    0: this.getDateLabel(),
                                },
                                ReturnType.HTML
                            )
                        );
                    }

                    this.errorMsgs = [...this.errorMsgs, ...this.patternError];
                }
            }

            if (
                this.patientDetailsForm.get('dateOfBirthStr')
                    .errors &&
                this.patientDetailsForm.get('dateOfBirthStr')
                    .errors.pattern
            ) {

                if (ispatternMsg) {
                    this.errorMsgs.push(
                        this.translate(
                            'label.gb.date_of_birth',
                            {},
                            ReturnType.HTML
                        )
                    );
                    this.errorMsgs.push(
                        this.translate(
                            'msg.cs816.text_appendix',
                            {
                                0: this.getDateLabel(),
                            },
                            ReturnType.HTML
                        )
                    );
                }

            }

            let msg = ispatternMsg ? 'msg.cs816.text' : 'msg.cs818.text';
            this.errorHeading = this.translate(msg, { 0: '' }, ReturnType.HTML);
            this.errorHeading = this.errorHeading
                .toString()
                .replace(/<br>/g, '');
            this.errorMsgs.unshift(this.errorHeading);
            var unique = this.errorMsgs.filter(function (item, i, ar) {
                return ar.indexOf(item) === i;
            });
            errorMsg = this.helperService.getErrorList(unique);
            this.isSavebtnClick = false;
            let productName = this.deviceForm.controls.productName,
                wrongDeviceTxt = this.translate('msg.pa825.text', '', 'html');
            if (!['', undefined, null].includes(productName.value) && productName.status == "INVALID") {
                this.toasterService.error(wrongDeviceTxt,
                    null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false,
                });
            }
            else {
                this.toasterService.error(errorMsg,
                    null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false,
                });
            }
            //  this.patientDeviceForm.markAsPristine();
            return;
        }
    }

    //this.userInfo?.dateFormat?.toUpperCase()

    getDateLabel() {
        let key =
            this.userInfo?.dateFormat?.toUpperCase() == 'DD-MM-YYYY'
                ? 'label.gb.ddmmyyyy'
                : this.dateLabel?.toUpperCase() == 'MM-DD-YYYY'
                    ? 'label.gb.mmddyyyy'
                    : 'label.gb.yyyymmdd';
        return this.localizationService.generateLocalizedStr(key);
    }

    errorHandling(controlItem, name) {
        if (name == 'countryCode' || name == 'areaCode' || name == 'phoneNum') {
            let countryCode = this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('countryCode');
            let areaCode = this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('areaCode');
            let phoneNumber = this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('phoneNum');

            if (
                controlItem?.errors?.pattern && (
                    countryCode.value ||
                    areaCode.value ||
                    phoneNumber.value)
            ) {
                this.errorHeading = this.translate(
                    FrontEndErrMsgs.invalidField,
                    { '0': '' },
                    ReturnType.HTML
                );

                if (this.errorMsgs.length == 0) {
                    countryCode.setErrors({ pattern: true });
                    areaCode.setErrors({ pattern: true });
                    phoneNumber.setErrors({ pattern: true });
                    countryCode.markAsTouched();
                    areaCode.markAsTouched();
                    phoneNumber.markAsTouched();

                    let mainPhone =
                        this.localizationService.generateLocalizedStr(
                            'label.gb.primary_phone_mobile'
                        );
                    if (!this.patternError.includes(mainPhone)) {
                        this.patternError.push(mainPhone);
                    }
                } else {
                    countryCode.clearValidators();
                    areaCode.clearValidators();
                    phoneNumber.clearValidators();
                    countryCode.setValidators([
                        Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                    ]);
                    phoneNumber.setValidators([
                        Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                    ]);
                    areaCode.setValidators([
                        Validators.pattern("^[0-9-,(), ' ', ., +]*$"),
                    ]);
                    countryCode.updateValueAndValidity();
                    areaCode.updateValueAndValidity();
                    phoneNumber.updateValueAndValidity();
                }

                return;
            }

            if (controlItem?.errors?.required) {
                this.errorHeading = this.translate(
                    FrontEndErrMsgs.reqHeading,
                    { '0': '' },
                    ReturnType.HTML
                );

                if (
                    !countryCode.value ||
                    !areaCode.value ||
                    !phoneNumber.value
                ) {
                    // if( !countryCode.value)
                    countryCode.setErrors({ require: true });
                    // if( !areaCode.value)
                    areaCode.setErrors({ require: true });
                    // if( !phoneNumber.value)
                    phoneNumber.setErrors({ require: true });
                    this.patientDeviceForm?.updateValueAndValidity();
                    var isPrimaryPhoneMandatory = this.patientDeviceForm
                        .get('directCallMsg')
                        .get('callContactTypeCd').value;
                    let mainPhone =
                        this.localizationService.generateLocalizedStr(
                            'label.gb.primary_phone_mobile'
                        );
                    if (!this.patternError.includes(mainPhone)) {
                        this.patternError.push(mainPhone);
                    }
                    if (this.isNGQCategory || this.isICMCategory) {
                        if (this.phoneValidations && this.emailValidations) {
                            this.errorMsgs.push(mainPhone)
                        } else if (isPrimaryPhoneMandatory == '993' || isPrimaryPhoneMandatory == '994' || this.countryCd == '140') {
                            this.errorMsgs.push(mainPhone)

                        }
                    } else if (isPrimaryPhoneMandatory == '993' || isPrimaryPhoneMandatory == '994' || this.countryCd == '140') {
                        this.errorMsgs.push(mainPhone)

                    }
                }
                if (
                    !countryCode.value &&
                    !areaCode.value &&
                    !phoneNumber.value
                ) {
                    if (!countryCode.value)
                        countryCode.setErrors({ require: true });
                    if (!areaCode.value)
                        areaCode.setErrors({ require: true });
                    if (!phoneNumber.value)
                        phoneNumber.setErrors({ require: true });

                    let mainPhone =
                        this.localizationService.generateLocalizedStr(
                            'label.gb.primary_phone_mobile'
                        );

                    if (!this.errorMsgs.includes(mainPhone)) {
                        this.errorMsgs.push(mainPhone);
                    }

                }
            }
            return;
        }
        if (isControlRequired(controlItem)) {
            this.isError = true;
            this.addRequiredErrorMessage(name);
        }
        if (controlItem?.errors?.incorrect && name === 'implantDate') {
            this.patternError.push(this.translate('label.gb.implant_date', {}, ReturnType.Text));
        } else if (
            controlItem?.errors?.incorrect &&
            name === 'dateOfBirthStr'
        ) {
            this.patternError.push(this.translate('label.gb.date_of_birth', {}, ReturnType.Text));
        }

        if (controlItem?.errors?.pattern) {
            if (['countryCode', 'areaCode', 'phoneNum'].includes(name)) {
                let errorItem = this.translate(
                    FrontEndErrMsgs['incorrectPhoneField'],
                    {},
                    ReturnType.HTML
                );
                if (!this.patternError.includes(errorItem)) {
                    this.patternError.push(
                        this.translate(
                            FrontEndErrMsgs['incorrectPhoneField'],
                            {},
                            ReturnType.HTML
                        )
                    );
                }
                this.phoneForm.get('countryCode').setErrors({ pattern: true });
                this.phoneForm.get('areaCode').setErrors({ pattern: true });
                this.phoneForm.get('phoneNum').setErrors({ pattern: true });
            } else {
                this.patternError.push(
                    this.translate(FrontEndErrMsgs[name], {}, ReturnType.HTML)
                );
            }
        } else if (name == 'phone') {
            const countryCode =
                controlItem.get('countryCode')?.errors?.required;
            const phoneNum = controlItem.get('phoneNum')?.errors?.required;
            const areaCode = controlItem.get('areaCode')?.errors?.required;
            const isCountryCodeIncorrect =
                controlItem.get('countryCode')?.errors?.incorrect;
            const isPhoneNumIncorrect =
                controlItem.get('phoneNum')?.errors?.incorrect;
            const isAreaCodeIncorrect =
                controlItem.get('areaCode')?.errors?.incorrect;
            // if (countryCode || phoneNum || areaCode) {
            //     if (countryCode) {
            //         if (FrontEndErrMsgs['countryCode']) {
            //             this.errorMsgs.push(
            //                 this.translate(
            //                     FrontEndErrMsgs['countryCode'],
            //                     {},
            //                     ReturnType.HTML
            //                 )
            //             );
            //         }
            //     } else if (phoneNum) {
            //         if (FrontEndErrMsgs['phoneNum']) {
            //             this.errorMsgs.push(
            //                 this.translate(
            //                     FrontEndErrMsgs['phoneNum'],
            //                     {},
            //                     ReturnType.HTML
            //                 )
            //             );
            //         }
            //     } else if (areaCode) {
            //         if (FrontEndErrMsgs['areaCode']) {
            //             this.errorMsgs.push(
            //                 this.translate(
            //                     FrontEndErrMsgs['areaCode'],
            //                     {},
            //                     ReturnType.HTML
            //                 )
            //             );
            //         }
            //     }
            //     this.isError = true;
            //     this.errorHeading = this.translate(
            //         FrontEndErrMsgs.reqHeading,
            //         { '0': '' },
            //         ReturnType.HTML
            //     );
            // } else

            if (
                isCountryCodeIncorrect ||
                isPhoneNumIncorrect ||
                isAreaCodeIncorrect
            ) {
                if (FrontEndErrMsgs['incorrectPhoneField']) {
                    this.errorMsgs.push(
                        this.translate(
                            FrontEndErrMsgs['incorrectPhoneField'],
                            {},
                            ReturnType.HTML
                        )
                    );
                    controlItem.get('countryCode').setErrors({ pattern: true });
                    controlItem.get('areaCode').setErrors({ pattern: true });
                    controlItem.get('phoneNum').setErrors({ pattern: true });
                }
            }
            this.isError = true;
            this.errorHeading = this.translate(
                FrontEndErrMsgs.reqHeading,
                { '0': '' },
                ReturnType.HTML
            );
        }

        if (controlItem?.errors?.invalidOption && name === 'implantPhyId') {
            this.errorMsgs.push(
                this.translate(
                FrontEndErrMsgs['implantPhyId'],
                {},
                ReturnType.HTML
            )
            );
        }
    }
    handleEmergencyCont(event) {
        const { $event, isEmerGencyOpen, cancelledUnsavePopup } = event;
        this.callingEmergencyCont = $event;
        this.toggleEmergencyCont = $event;
        this.cancelledCM819 = cancelledUnsavePopup;
        if ((this.profileMode() || this.displayMode == 'enroll') && $event) {
            if (this.patientDetailsForm.get('insNumber').value && this.patientDetailsForm.get('insNumber').value !== '') {
                this.checkInsInfo(false, false, isEmerGencyOpen);
            } else {
                this.continue(false, isEmerGencyOpen);
            }
        }
        if (this.profileMode() && !$event) {
            if (this.displayMode === 'view') {
                if (!isEmerGencyOpen) {
                    this.setDisplayMode('view');
                }
            } else {
                this.setDisplayMode('edit');
            }
        }
    }

    public submit(devData, saveOpt) {
        this.enrollService
            .updateDeviceData(devData, this.functionMode, this.patientid)
            .subscribe(
                (res) => {
                    this.spinnerSer.visibility = false;
                    this.patientDeviceData = res;
                    if (this.callingEmergencyCont) {
                        this.enrollService.patientId.next(
                            res.patient.patientId
                        );
                        this.enrollService.countryCd =
                            this.userInfo.clinicCountryCd;
                        this.countryCd = this.userInfo.clinicCountryCd;
                        this.toggleEmergencyCont = true;
                        setTimeout(() => {
                            this.toggleEmergencyCont = false;
                            this.enrollService.showEmergencyContactPopup.next(
                                false
                            );
                        }, 1000);
                    } else {
                        this.toggleEmergencyCont = false;
                        this.enrollService.showEmergencyContactPopup.next(
                            false
                        );
                        if (saveOpt) {
                            this.enrollService.patientId.next(
                                res.patient.patientId
                            );
                            this.getPatientId.emit(res.patient.patientId);
                            this.navigateToTrans.emit('next');
                        } else {
                            this.cancel();
                        }
                    }
                },
                (err) => {
                    this.updateErrorHandling(err);
                    this.spinnerSer.visibility = false;
                }
            );
    }

    public updateErrorHandling(err) {
        if (err.fields) {
            err.fields.forEach((ele) => {
                const item = ele;

                for (let i in (
                    this.patientDeviceForm?.get('deviceData') as FormGroup
                ).controls) {
                    if (i == item) {
                        this.patientDeviceForm
                            .get('deviceData')
                            .get(i)
                            .setErrors({ incorrect: true });
                        this.patientDeviceForm.markAllAsTouched();
                    } else {
                        this.patientDeviceForm
                            .get('deviceData')
                            .get(i)
                            .updateValueAndValidity();
                    }
                }
                for (let i in (
                    this.patientDeviceForm?.get('patientDetails') as FormGroup
                ).controls) {
                    if (i == item) {
                        this.patientDeviceForm
                            .get('patientDetails')
                            .get(i)
                            .setErrors({ incorrect: true });
                        this.patientDeviceForm.markAllAsTouched();
                    } else {
                        this.patientDeviceForm
                            .get('patientDetails')
                            .get(i)
                            .updateValueAndValidity();
                    }
                }
                for (let i in (
                    this.patientDeviceForm
                        .get('patientDetails')
                        .get('phone') as FormGroup
                ).controls) {
                    if (i == item) {
                        this.patientDeviceForm
                            .get('patientDetails')
                            .get('phone')
                            .get(i)
                            .setErrors({ incorrect: true });
                        this.patientDeviceForm.markAllAsTouched();
                    }
                }
                for (let i in (
                    this.patientDeviceForm?.get('directCallMsg') as FormGroup
                ).controls) {
                    if (i == item) {
                        this.patientDeviceForm
                            .get('directCallMsg')
                            .get(i)
                            .setErrors({ incorrect: true });
                        if (i == 'msgStartTime') {
                            this.patientDeviceForm
                                .get('directCallMsg')
                                .get('msgStartAmpm')
                                .setErrors({ incorrect: true });
                        }
                        if (i == 'msgEndTime') {
                            this.patientDeviceForm
                                .get('directCallMsg')
                                .get('msgEndAmpm')
                                .setErrors({ incorrect: true });
                        }
                        this.patientDeviceForm.markAllAsTouched();
                    }
                }
            });
        }
        if (err && err.msgs) {
            this.isError = true;
            err.msgs.forEach((m) => {
                this.errorHeading = ErrorCodes[m.msg];
                if (m.msg === 'msg.pa854a.text') {
                    this.patientDeviceForm
                        .get('patientDetails')
                        .get('patientNum')
                        .setErrors({ incorrect: true });
                    this.patientDeviceForm.markAllAsTouched();
                } else {
                    this.patientDeviceForm
                        .get('patientDetails')
                        .get('patientNum')
                        .updateValueAndValidity();
                }
                m.childs.forEach((item) => {
                    let errorCode = ErrorCodes[item.msg];
                    const data = item.childs;
                    if (errorCode.indexOf('{0}') > -1) {
                        const repVal =
                            ErrorCodes[data[0].msg] +
                            ' ' +
                            ErrorCodes[data[1].msg];
                        errorCode = errorCode.replaceAll('{0}', repVal);
                    }
                    if (errorCode.indexOf('{1}') > -1) {
                        const repVal =
                            ErrorCodes[data[0].msg] +
                            ' ' +
                            ErrorCodes[data[2].msg];
                        errorCode = errorCode.replaceAll('{1}', repVal);
                    }
                    this.errorMsgs.push(errorCode);
                });
            });
        }
    }

        public toggleValidations() {
        if (this.showPhysicianOpt) {
            this.showPhysicianOpt = true;
            this.patientDeviceForm
                .get('deviceData')
                .get('implantDate')
                .setValidators(Validators.required);
            this.patientDeviceForm
                .get('deviceData')
                .get('implantPhyId')
                .setValidators(Validators.required);
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('address')
                .setValidators(Validators.required);
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('city')
                .setValidators(Validators.required);
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('state')
                .setValidators(Validators.required);
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('zipCode')
                .setValidators([
                    Validators.required,
                    Validators.pattern(new RegExp(/^[0-9]*$/)),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('countryCode')
                .setValidators([
                    Validators.required,
                    Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('areaCode')
                .setValidators([
                    Validators.required,
                    Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('phoneNum')
                .setValidators([
                    Validators.required,
                    Validators.pattern(new RegExp(/^[0-9-.,()+' ']*$/)),
                ]);
        } else {
            this.showPhysicianOpt = false;
            this.patientDeviceForm
                .get('deviceData')
                .get('implantDate')
                .clearValidators();
            this.patientDeviceForm
                .get('deviceData')
                .get('implantPhyId')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('address')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('city')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('state')
                .clearValidators();
            this.patientDeviceForm
                .get('patientDetails')
                .get('address')
                .get('zipCode')
                .setValidators([Validators.pattern(new RegExp(/^[0-9]*$/))]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('countryCode')
                .setValidators([
                    Validators.pattern(new RegExp(/^-?([1-9]\d*)?$/)),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('areaCode')
                .setValidators([
                    Validators.pattern(new RegExp(/^-?([1-9]\d*)?$/)),
                ]);
            this.patientDeviceForm
                .get('patientDetails')
                .get('phone')
                .get('phoneNum')
                .setValidators([
                    Validators.pattern(new RegExp(/^-?([1-9]\d*)?$/)),
                ]);
        }
        this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('countryCode')
            .updateValueAndValidity();
        this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('areaCode')
            .updateValueAndValidity();
        this.patientDeviceForm
            .get('patientDetails')
            .get('phone')
            .get('phoneNum')
            .updateValueAndValidity();
        this.patientDeviceForm
            .get('patientDetails')
            .get('address')
            .get('zipCode')
            .updateValueAndValidity();
    }

    assignFormValues() {
        this.deviceForm.patchValue(this.patientDeviceForm?.get('deviceData'));
        this.patientDetailsForm.patchValue(
            this.patientDeviceForm?.get('patientDetails')
        );
        this.messageForm.patchValue(
            this.patientDeviceForm?.get('directCallMsg')
        );
        this.updateDevideInfo.messaging = this.messageForm.getRawValue();

        if (this.functionMode === 'enroll') {
            this.updateDevideInfo.messaging.msgOverdueFlg = this.msgOverdueFlgValue;
            this.updateDevideInfo.messaging.msgReminderFlg = this.msgReminderFlgValue;
        } else if (this.functionMode === 'profile' && this.displayMode === 'edit') {
            const clinicMsgOverdueFlg = this.clinicDetailsInfo?.msgOverdueFlg;
            const clinicMsgReminderFlg = this.clinicDetailsInfo?.msgReminderFlg;
            const effectiveOverdueFlg = this.msgOverdueFlgValue ?? this.messageForm.get('msgOverdueFlg')?.value;
            const effectiveReminderFlg = this.msgReminderFlgValue ?? this.messageForm.get('msgReminderFlg')?.value;

            if (effectiveOverdueFlg === clinicMsgOverdueFlg) {
                this.updateDevideInfo.messaging.msgOverdueFlg = null;
            } else {
                this.updateDevideInfo.messaging.msgOverdueFlg = effectiveOverdueFlg;
            }

            if (effectiveReminderFlg === clinicMsgReminderFlg) {
                this.updateDevideInfo.messaging.msgReminderFlg = null;
            } else {
                this.updateDevideInfo.messaging.msgReminderFlg = effectiveReminderFlg;
            }
        }
        // Convert to patientDevices array format
        const deviceFormData = this.deviceForm.getRawValue();
        deviceFormData.dataMiningFlg = deviceFormData?.dataMiningFlg ? deviceFormData.dataMiningFlg : false;

        // Extract DR device flag and data before creating primary device
        const drDeviceEnabled = deviceFormData.drDevice;
        const drSerialNum = deviceFormData.drSerialNum;
        const drProductId = deviceFormData.drProductId;
        const drProductName = deviceFormData.drProductName;
        const drImplantDate = deviceFormData.drImplantDate;
        const drImplantPhyId = deviceFormData.drImplantPhyId;
        const drImplantPhyIdName = deviceFormData.drImplantPhyIdName;
        const drPrevProductId = deviceFormData.drPrevProductId;
        const drPrevSerialNum = deviceFormData.drPrevSerialNum;
        const drPrevPatientDeviceId = deviceFormData.drPrevPatientDeviceId;
        const drPatientDeviceId = deviceFormData.drPatientDeviceId;
        const drEditReason = deviceFormData.drEditReason;
        const drDevChanged = deviceFormData.drDevChanged;
        const drModelNum = deviceFormData.drModelNum;
        // Create primary device object with all API-required fields per contract
        const primaryDeviceData = {
            dataMiningFlg: deviceFormData.dataMiningFlg || false,
            devChanged: deviceFormData.devChanged || false,
            editReason: deviceFormData.editReason || null,
            implantDate: deviceFormData.implantDate || null,
            implanterIds: deviceFormData.implanterIds || [],
            implantPhyId: deviceFormData.implantPhyId || null,
            leadChmbSettingCd: deviceFormData.leadChmbSettingCd || null,
            modelNum: deviceFormData.modelNum,
            prevPatientDeviceId: drPrevPatientDeviceId,
            prevProductId:  drPrevProductId,
            prevSerialNum: drPrevSerialNum,
            productId: deviceFormData.productId,
            productName: deviceFormData.productName || null,
            search: deviceFormData.search || "",
            serialNum: deviceFormData.serialNum,
            transmitter: deviceFormData.transmitter || false,
            transPatientImplantPhyIdData: deviceFormData.transPatientImplantPhyIdData || "--",
            isICMDevice: false,
            patientDeviceId: deviceFormData.patientDeviceId,
            isImplantPhysicianEditable: deviceFormData.isImplantPhysicianEditable
        };

        // Read removal state set by child component Remove buttons
        const deviceRemovalState = deviceFormData.deviceRemovalState || 'none';

        if (deviceRemovalState === 'primary') {
            // Primary device was removed: DR device becomes the sole device in payload
            const drOnlyDevice = {
                dataMiningFlg: false,
                devChanged: drDevChanged || false,
                editReason: drEditReason || null,
                implantDate: drImplantDate || null,
                implanterIds: [],
                implantPhyId: drImplantPhyId || null,
                leadChmbSettingCd: null,
                modelNum: drModelNum,
                prevPatientDeviceId: drPrevPatientDeviceId,
                prevProductId: drPrevProductId,
                prevSerialNum: drPrevSerialNum,
                productId: drProductId,
                productName: drProductName || null,
                search: "",
                serialNum: drSerialNum,
                transmitter: false,
                transPatientImplantPhyIdData: deviceFormData.drTransPatientImplantPhyIdData || "--",
                isICMDevice: false,
                patientDeviceId: drPatientDeviceId,
                isImplantPhysicianEditable: deviceFormData.isImplantPhysicianEditableDR
            };
            this.updateDevideInfo.patientDevices = drSerialNum && drProductId ? [drOnlyDevice] : [primaryDeviceData];
        } else if (deviceRemovalState === 'dr') {
            // DR device was removed: send only the primary device
            this.updateDevideInfo.patientDevices = [primaryDeviceData];
        } else {
            // Normal flow: initialize with primary device
            this.updateDevideInfo.patientDevices = [primaryDeviceData];

            // Include DR device if fields are populated with valid data.
            // The checkbox state is intentionally NOT used as the gate here — unchecking the DR
            // checkbox in edit mode should NOT remove the second device from the payload.
            // Removal only happens when the Remove button is clicked (deviceRemovalState === 'dr'),
            // which is handled by the else-if branch above.
            if (drSerialNum && drProductId) {
                const drDeviceData = {
                    dataMiningFlg: false,
                    devChanged: drDevChanged || false,
                    editReason: drEditReason || null,
                    implantDate: drImplantDate || null,
                    implanterIds: [],
                    implantPhyId: drImplantPhyId || null,
                    leadChmbSettingCd: null,
                    modelNum: drModelNum,
                    prevPatientDeviceId: drPrevPatientDeviceId,
                    prevProductId: drPrevProductId,
                    prevSerialNum: drPrevSerialNum,
                    productId: drProductId,
                    productName: drProductName || null,
                    search: "",
                    serialNum: drSerialNum,
                    transmitter: false,
                    transPatientImplantPhyIdData: deviceFormData.drTransPatientImplantPhyIdData || "--",
                    isICMDevice: false,
                    patientDeviceId: drPatientDeviceId,
                    isImplantPhysicianEditable: deviceFormData.isImplantPhysicianEditableDR
                };
                this.updateDevideInfo.patientDevices.push(drDeviceData);
            }
        }
        this.updateDevideInfo.patient = this.patientDetailsForm.getRawValue();
        // TODO use localization service to call normalize date function
        function normalizeDateFormat(dateStr: string): string {
            if (!dateStr) return '';
            // Replace dot or slash with dash
            return dateStr.replace(/[./]/g, '-');
        }
        this.updateDevideInfo.patient.dateOfBirthStr = normalizeDateFormat(
            this.updateDevideInfo.patient.dateOfBirthStr
        );
        this.updateDevideInfo.patient.dateOfBirthStr =
            this.updateDevideInfo.patient.dateOfBirthStr
                ? this.helperService.formatDate(
                    this.updateDevideInfo.patient.dateOfBirthStr
                )
                : null;
        try {
            // Normalize implant dates for all devices in the array
            if (this.updateDevideInfo.patientDevices && Array.isArray(this.updateDevideInfo.patientDevices)) {
                this.updateDevideInfo.patientDevices.forEach((device, index) => {
                    if (device && device.implantDate) {
                        device.implantDate = normalizeDateFormat(device.implantDate);
                        device.implantDate =
                            device.implantDate
                            ? this.helperService.formatDate(
                                device.implantDate
                            ) : null;
                    }
                });
            }
        } catch (error) { }
        this.updateDevideInfo.clinicDetails.dateFormatLocale =
            this.updateDevideInfo.clinicDetails.dateFormatLocale;
        this.updateDevideInfo.medTeam.implantPhyId = this.implantPhyId ? this.implantPhyId : this.patientDeviceData?.medTeam?.implantPhyId;
        if (this.selectedAssignedIds?.length) {
            this.updateDevideInfo.medTeam.assigned = this.selectedAssignedIds;
        }
        if (this.remainAvaliableIds?.length) {
            this.updateDevideInfo.medTeam.availableIds =
                this.remainAvaliableIds;
        }
        this.patRes = this.updateDevideInfo;

        // Ensure patientDevices array exists and has at least one element
        if (!this.patRes.patientDevices) {
            this.patRes.patientDevices = [{}];
        } else if (!Array.isArray(this.patRes.patientDevices)) {
            // Convert old single object to array format
            this.patRes.patientDevices = [this.patRes.patientDevices];
        } else if (this.patRes.patientDevices.length === 0) {
            this.patRes.patientDevices = [{}];
        }

        // Now safely set properties on the first device
        const primaryDevice = this.patRes.patientDevices[0];
        primaryDevice.prevPatientDeviceId = this.patientDeviceInfo?.prevPatientDeviceId;
        primaryDevice.prevProductId = this.patientDeviceInfo?.prevProductId;
        primaryDevice.prevSerialNum = this.patientDeviceInfo?.prevSerialNum;

        if (this.profileMode()) {
            if (this.selectedAssignedIds?.length) {
                this.patRes.medTeam.assigned = this.selectedAssignedIds;
            }
            if (this.remainAvaliableIds?.length) {
                this.patRes.medTeam.availableIds = this.remainAvaliableIds;
            }
            primaryDevice.patientDeviceId = this.patientDeviceInfo?.patientDeviceId;
            primaryDevice.isICMDevice = this.patientDeviceInfo?.isICMDevice;
        }

        if (
            primaryDevice.prevSerialNum !== null &&
            primaryDevice.prevProductId !== null &&
            (primaryDevice.prevSerialNum != primaryDevice.serialNum ||
                primaryDevice.prevProductId != primaryDevice.productId)
        ) {
            primaryDevice.devChanged = true;
        }

        // Check if secondary device (DR device) has changed
        if (this.patRes.patientDevices && this.patRes.patientDevices.length > 1) {
            const secondaryDevice = this.patRes.patientDevices[1];
            if (
                secondaryDevice.prevSerialNum !== null &&
                secondaryDevice.prevProductId !== null &&
                (secondaryDevice.prevSerialNum != secondaryDevice.serialNum ||
                    secondaryDevice.prevProductId != secondaryDevice.productId)
            ) {
                secondaryDevice.devChanged = true;
            }
        }
    }
    markImplantPhyIdSel(e) {
        if (e && typeof e.getAttribute === 'function') {
            try {
                const ImplantPhyObj = JSON.parse(e.getAttribute('value'));
                this.implantPhyId = ImplantPhyObj.acctId;
            } catch (error) {
                console.error('Error parsing implant physician data:', error);
            }
        }
    }

    profileMode() {
        if (this.functionMode === FunctionMode.PROFILE) {
            return true;
        } else {
            return false;
        }
    }

    viewMode() {
        if (this.displayMode === FunctionMode.VIEW) {
            return true;
        } else {
            return false;
        }
    }

    editMode() {
        if (this.displayMode === FunctionMode.EDIT) {
            return true;
        } else {
            return false;
        }
    }

    setDisplayMode(value: string) {
        this.setParentDisplayMode(value);
        this.displayMode = value;
    }

    displayEditUI() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    cancelEditClick() {
        this.isSavebtnClick = false;
        this.toasterService.clear();
        this.cancel();
        this.commonService.setDataCorrectedValue(false);
    }

    setHeader(data) {
        this.setPatientHeader.emit({
            name: `${data.patient.firstName} ${data.patient.lastName}`,
            deviceName: this.getDeviceName(data),
            num: data.patient.patientNum,
        });
    }

    emitSubMenuData(val: boolean) {
        this.setSubMenu.emit(val);
    }

    getProductNameById(productId) {
        let dev = this.dropDownInfo?.devices?.filter((product) => {
            return +product.value === +productId
        });
        if (dev.length == 0) {
            return '';
        }
        return dev[0].label;
    }

    getDeviceName(data) {
        const primaryDevice = this.enrollService.getPrimaryPatientDevice(data);
        if (!primaryDevice) return '';

        let patDevice = data.dropdowns?.devices.filter((dev) => {
            return dev.value == primaryDevice.productId;
        });
        if (patDevice.length == 0) {
            return '';
        }
        return patDevice[0].label;
    }

    showToaster(actionErrors: ActionError[]) {
        this.errorMsgs = [];
        this.patternError = [];
        actionErrors.forEach((item) => {
            const allKeys = Object.keys(item.parameters ?? {});
            let message = this.translate(item.message, {}, ReturnType.HTML);
            allKeys.forEach((key) => {
                const param = item.parameters[key].message;
                message = message.replace(`{${key}}`, param);
            });

            this.errorMsgs.push(message);
            const errorMsg = this.helperService.getErrorList(this.errorMsgs);
            if (actionErrors.length == this.errorMsgs.length) {
                this.isSavebtnClick = false;
                this.toasterService.error(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: false,
                    tapToDismiss: false,
                });
            }
        });
    }
    checkFormUpdated(saveOpt, emergency) {
        if (!this.patientid || Number(this.patientid) < 1) {
            this.enrollService.isStepBackFromEnroll = false;
            this.updateDeviceData(this.updateDevideInfo, saveOpt, emergency);
            return;
        }
        let keyFound;
        return this.getExistingPatientFunc(
                this.patientid,
                (res) => {
                    this.getPatientProfile(res);
                    Object.keys(this.PatientInfo).forEach((key) => {
                    if (key === 'address') {
                        if (
                            this.PatientInfo.address[key] !=
                            this.patRes.patient.address[key] &&
                            this.patRes.patient.address[key] != 'null'
                        ) {
                            return (keyFound = key);
                        }
                    } else if (key === 'phone') {
                        if (
                            this.PatientInfo.phone[key] !=
                            this.patRes.patient.phone[key] &&
                            this.patRes.patient.phone[key] != 'null'
                        ) {
                            return (keyFound = key);
                        }
                    } else if (
                        this.PatientInfo[key] != this.patRes.patient[key] &&
                        this.patRes.patient[key] != 'null'
                    ) {
                        return (keyFound = key);
                    }
                });

                Object.keys(this.clinicDetailsInfo).forEach((key) => {
                    if (
                        this.clinicDetailsInfo[key] !=
                        this.patRes.clinicDetails[key] &&
                        this.patRes.clinicDetails[key] != 'null'
                    ) {
                        return (keyFound = key);
                    }
                });

                if (
                    res?.medTeam?.assigned &&
                    res.medTeam.assigned?.length !==
                    this.patRes?.medTeam?.assigned?.length
                ) {
                    keyFound = true;
                } else if (
                    res?.medTeam?.availableIds &&
                    res.medTeam.availableIds?.length !==
                    this.patRes?.medTeam?.availableIds?.length
                ) {
                    keyFound = true;
                }
                if (this.messagingInfo != null) {
                    Object.keys(this.messagingInfo).forEach((key) => {
                        if (
                            this.messagingInfo[key] !=
                            this.patRes.messaging[key] &&
                            this.patRes.messaging[key] != 'null'
                        ) {
                            return (keyFound = key);
                        }
                    });
                }
                Object.keys(this.patientDeviceInfo).forEach((key) => {
                    if (
                        this.patientDeviceInfo[key] !=
                        this.patRes.patientDevices?.[0]?.[key] &&
                        this.patRes.patientDevices?.[0]?.[key] != 'null' &&
                        key != 'implanterIds' &&
                        key != 'leadChmbSettingCd' &&
                        key != 'productId'
                    ) {
                        return (keyFound = key);
                    }
                });
                this.patRes = {
                    ...this.patRes,
                    dropdowns: res.dropdowns
                }
                //   return keyFound || 0;
                if (keyFound || this.patRes.patientDevices.devChanged) {
                    //37461 start
                    this.updateDevideInfo = {
                        ...this.updateDevideInfo,
                        patient: {
                            ...this.updateDevideInfo.patient,
                            address: {
                                ...this.updateDevideInfo?.patient?.address,
                                addressId: res?.patient?.address.addressId,
                            },
                            phone: {
                                ...this.updateDevideInfo?.patient?.phone,
                                phoneId: res?.patient?.phone.phoneId,
                            },
                            merlinNetId: res?.patient?.merlinNetId,
                        },
                    };
                    if(keyFound==='isAveirDevice' && this.updateDevideInfo.patientDevices.length == res.patientDevices.length){
                        this.updateDevideInfo ={
                            ...this.updateDevideInfo,
                           patientDevices: this.updateDevideInfo.patientDevices.map((device) => {
                                const matchingDevice = res.patientDevices.find(resDevice =>
                                    resDevice.serialNum == device.serialNum &&
                                    resDevice.productId == device.productId
                                );
                                if(matchingDevice){
                                    return {
                                        ...device,
                                        patientDeviceId: matchingDevice?.patientDeviceId
                                    }
                                }
                                return device;
                            })
                        }
                    if (this.updateDevideInfo?.patientDevices?.[0] && res.patientDevices[0]) {
                       // this.updateDevideInfo.patientDevices[0].leadChmbSettingCd = res.patientDevices[0]?.leadChmbSettingCd;
                        this.updateDevideInfo.patientDevices[0].patientDeviceId = res.patientDevices[0]?.patientDeviceId;
                        this.updateDevideInfo.patientDevices[0].prevPatientDeviceId = res.patientDevices[0]?.prevPatientDeviceId;
                        this.updateDevideInfo.patientDevices[0].prevProductId = res.patientDevices[0]?.prevProductId;
                        this.updateDevideInfo.patientDevices[0].prevSerialNum = res.patientDevices[0]?.prevSerialNum;
                    }
                    }
                    ////37461 end
                    let isFormModified = true;
                    this.route.params.subscribe((res) => {
                        (res?.id && this.functionMode == 'enroll') ? isFormModified = false : '';
                    });
                    this.updateDeviceData(
                        this.updateDevideInfo,
                        saveOpt,
                        emergency,
                        isFormModified,
                        res
                    );
                } else {
                    return this.cancelEditClick();
                }
            });
    }

    onDateRangeChange() {
        let fields = ['msgStartTime','msgEndTime']
        for(let field of fields){
            const control = this.patientDeviceForm?.get('directCallMsg')?.get(field);
            //remove invalid dateRange validation from field on input
            control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(()=>{
                this.clearInvalidErrorState('directCallMsg', field);
            })
        }
    }

    translate(key, params, returnType) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            returnType
        );
    }

    makeEmergencyContactPopupFalse() {
        this.enrollService.showEmergencyContactPopup.next(false);
        this.enrollService.openEmergencyDialog(false);
        this.toggleEmergencyCont = false;
        this.callingEmergencyCont = false;
    }

    addRequiredErrorMessage(name) {
        this.errorHeading = this.translate(
            FrontEndErrMsgs.reqHeading,
            { '0': '' },
            ReturnType.HTML
        );
        if (FrontEndErrMsgs[name]) {
            this.errorMsgs.push(
                this.translate(FrontEndErrMsgs[name], {}, ReturnType.HTML)
            );
        }
    }

    public openDialog() {
        const insInformationDRef = this.dialog.open(InsInformationDialogComponent, {
            width: '40%',
            data: {
                patientData: this.patientData

            },
        });
        insInformationDRef.afterClosed().subscribe(result => {
            this.isSavebtnClick = false;
            if (!result?.isClickConfirm) {
                this.patientDeviceForm
                    .get('patientDetails')
                    .get('insNumber').reset();
                this.isConfirmClick = false;
            } else {
                this.isConfirmClick = true;
                const lifenPatientData = result?.patientData;
                let fieldsToChange = ['firstName', 'givenNames', 'usedGivenName', 'lastName', 'usedLastName', 'placeOfBirth', 'dateOfBirthStr', 'oidNumber', 'genderCd']
                fieldsToChange.forEach(field => {
                    if (this.patientDeviceForm
                        .get('patientDetails')
                        .get(field)?.value !== lifenPatientData?.patient[field]) {
                        this.patientDeviceForm
                            .get('patientDetails')
                            .get(field).patchValue(lifenPatientData?.patient[field]);
                    }
                })
                // if(this.isSaveClick)
                //     this.save()
                // if(this.isContinueClick)
                //     this.continue(true);
            }

        })

        return insInformationDRef.afterClosed().toPromise();

    }

    handleImplatPhyIdInput() {
        const implantPhyIdCtrl = this.deviceForm.get('implantPhyId');
        const implantPhyIdNameCtrl = this.deviceForm.get('implantPhyIdName');
        const implantPhyIdVal = implantPhyIdCtrl?.value;
        if(this.deviceForm.get('transPatientImplantPhyIdData')?.value!='--' && implantPhyIdVal) return; // released patient with implant phy is not editable, skip validation
        if (typeof implantPhyIdVal !== 'string') {
            // If it's a number/ID and implantPhyIdName has a value, assume it's valid
            if (implantPhyIdVal && implantPhyIdNameCtrl?.value) {
                implantPhyIdCtrl?.setErrors(null);
                implantPhyIdNameCtrl?.setErrors(null);
            }
            return;
        }

        if ((!implantPhyIdVal || implantPhyIdVal.trim() === '') && implantPhyIdNameCtrl?.value) {
            // some value is entered in the name field but the ID field is blank - treat as invalid
            implantPhyIdCtrl?.setErrors({ pattern: true });
            implantPhyIdNameCtrl?.setErrors({ pattern: true });
            return;
        }
        if(this.isICMCategory && this.userInfo.clinicCountryCd === CountryCdEnum.USA){
            if ((!implantPhyIdVal || implantPhyIdVal.trim() === '') && !implantPhyIdNameCtrl?.value) {
                implantPhyIdCtrl?.setErrors({ invalidOption: true });
                implantPhyIdNameCtrl?.setErrors({ invalidOption: true });
                return;
            }

            const numericId = Number(implantPhyIdVal.trim());
            if (!isNaN(numericId) && numericId > 0) {
                // Look up physician by acctId in implantIds or full clinicians list
                const allClinicians = this.patientDeviceData?.dropdowns?.clinicians;
                const matchById = this.implantIds?.find(opt => opt.acctId == numericId)
                    ?? allClinicians?.find(opt => opt.acctId == numericId);
                if (matchById) {
                    // Ensure implantPhyIdName is populated with the physician object
                    if (!implantPhyIdNameCtrl?.value || typeof implantPhyIdNameCtrl.value !== 'object') {
                        implantPhyIdNameCtrl?.patchValue(matchById, { emitEvent: false });
                    }
                    implantPhyIdCtrl?.setErrors(null);
                    implantPhyIdNameCtrl?.setErrors(null);
                } else if (implantPhyIdNameCtrl?.value) {
                    // Numeric ID present with a name value — treat as valid
                    implantPhyIdCtrl?.setErrors(null);
                    implantPhyIdNameCtrl?.setErrors(null);
                } else {
                    implantPhyIdCtrl?.setErrors({ invalidOption: true });
                    implantPhyIdNameCtrl?.setErrors({ invalidOption: true });
                }
                return;
            }

            const input = implantPhyIdVal.trim().toLocaleLowerCase();
            const match = this.implantIds?.find(opt =>
                this.getImpData(opt)?.toLocaleLowerCase() === input
            );

            if (match) {
                implantPhyIdCtrl?.patchValue(match.acctId, { emitEvent: false });
                implantPhyIdNameCtrl?.patchValue(match, { emitEvent: false });

                implantPhyIdCtrl?.setErrors(null);
                implantPhyIdNameCtrl?.setErrors(null);
            } else {
                implantPhyIdCtrl?.setErrors({ invalidOption: true });
                implantPhyIdNameCtrl?.setErrors({ invalidOption: true });
            }
        }
        if(this.isLPCategory && this.patRes.patientDevices.length > 1 && this.deviceForm.get('drImplantPhyIdName')?.value){
            const drImplantPhyIdNameCtrl = this.deviceForm.get('drImplantPhyIdName');
            const drImplantPhyIdCtrl = this.deviceForm.get('drImplantPhyId');
            const drImplantPhyIdVal = drImplantPhyIdCtrl?.value;
            if ((!drImplantPhyIdVal || drImplantPhyIdVal.trim() === '') && drImplantPhyIdNameCtrl?.value) {
                // some value is entered in the name field but the ID field is blank - treat as invalid
                drImplantPhyIdCtrl?.setErrors({ pattern: true });
                drImplantPhyIdNameCtrl?.setErrors({ pattern: true });
                return;
            }
        }
    }

    getImpData(patPhys) {
        const mainLocation = (patPhys?.mainLocation || "").trim();
        const lastName = (patPhys?.lastName || "").trim();
        const firstName = (patPhys?.firstName || "").trim();
        const middleName = (patPhys?.middleName || "").trim();

        const credentials = patPhys?.credentialsCd ? String(patPhys.credentialsCd).trim() : "";

        const namePart = [ `${lastName},`, firstName, middleName, credentials ]
            .filter(Boolean)
            .join(" ")
            .replace(/\s+/g, " ")
            .trim();

        const full = mainLocation ? `${mainLocation}: ${namePart}` : namePart;

        return full.toLowerCase();
    }
}
